/* tslint:disable */
/* eslint-disable */
/**
 * Basic Selfcare Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { AxiosInstance, AxiosPromise, RawAxiosRequestConfig } from "axios";
import globalAxios from "axios";
import type { RequestArgs } from "../base";
// @ts-ignore
import { BASE_PATH, BaseAPI, COLLECTION_FORMATS, operationServerMap, RequiredError } from "../base";
// Some imports not used depending on template conditions
// @ts-ignore
import {
    assertParamExists,
    createRequestFunction,
    DUMMY_BASE_URL,
    serializeDataIfNeeded,
    setApiKeyToObject,
    setBasicAuthToObject,
    setBearerAuthToObject,
    setOAuthToObject,
    setSearchParams,
    toPathString,
} from "../common";
import type { Configuration } from "../configuration";

/**
 *
 * @export
 * @interface AccountCodeCap
 */
export interface AccountCodeCap {
    /**
     *
     * @type {string}
     * @memberof AccountCodeCap
     */
    availability?: AccountCodeCapAvailabilityEnum;
    /**
     *
     * @type {string}
     * @memberof AccountCodeCap
     */
    changeable?: AccountCodeCapChangeableEnum;
    /**
     *
     * @type {number}
     * @memberof AccountCodeCap
     */
    codeLength?: number;
    /**
     *
     * @type {string}
     * @memberof AccountCodeCap
     */
    predefinable?: AccountCodeCapPredefinableEnum;
}

export const AccountCodeCapAvailabilityEnum = {
    Party: "PARTY",
    Puid: "PUID",
} as const;

export type AccountCodeCapAvailabilityEnum = (typeof AccountCodeCapAvailabilityEnum)[keyof typeof AccountCodeCapAvailabilityEnum];
export const AccountCodeCapChangeableEnum = {
    CanModify: "CAN_MODIFY",
    ReadOnly: "READ_ONLY",
} as const;

export type AccountCodeCapChangeableEnum = (typeof AccountCodeCapChangeableEnum)[keyof typeof AccountCodeCapChangeableEnum];
export const AccountCodeCapPredefinableEnum = {
    Predefinable: "PREDEFINABLE",
    None: "NONE",
} as const;

export type AccountCodeCapPredefinableEnum = (typeof AccountCodeCapPredefinableEnum)[keyof typeof AccountCodeCapPredefinableEnum];

/**
 *
 * @export
 * @interface AnonymousCallRejection
 */
export interface AnonymousCallRejection {
    /**
     *
     * @type {Array<SelectiveDNEntry>}
     * @memberof AnonymousCallRejection
     */
    acrList?: Array<SelectiveDNEntry>;
    /**
     *
     * @type {string}
     * @memberof AnonymousCallRejection
     */
    inherit?: AnonymousCallRejectionInheritEnum;
    /**
     *
     * @type {boolean}
     * @memberof AnonymousCallRejection
     */
    pingRing?: boolean;
    /**
     *
     * @type {string}
     * @memberof AnonymousCallRejection
     */
    status?: AnonymousCallRejectionStatusEnum;
}

export const AnonymousCallRejectionInheritEnum = {
    Primary: "PRIMARY",
    Self: "SELF",
} as const;

export type AnonymousCallRejectionInheritEnum = (typeof AnonymousCallRejectionInheritEnum)[keyof typeof AnonymousCallRejectionInheritEnum];
export const AnonymousCallRejectionStatusEnum = {
    On: "ON",
    Off: "OFF",
} as const;

export type AnonymousCallRejectionStatusEnum = (typeof AnonymousCallRejectionStatusEnum)[keyof typeof AnonymousCallRejectionStatusEnum];

/**
 *
 * @export
 * @interface AnonymousCallRejectionCap
 */
export interface AnonymousCallRejectionCap {
    /**
     *
     * @type {string}
     * @memberof AnonymousCallRejectionCap
     */
    availability?: AnonymousCallRejectionCapAvailabilityEnum;
    /**
     *
     * @type {string}
     * @memberof AnonymousCallRejectionCap
     */
    changeable?: AnonymousCallRejectionCapChangeableEnum;
    /**
     *
     * @type {string}
     * @memberof AnonymousCallRejectionCap
     */
    predefinable?: AnonymousCallRejectionCapPredefinableEnum;
}

export const AnonymousCallRejectionCapAvailabilityEnum = {
    Party: "PARTY",
    Puid: "PUID",
} as const;

export type AnonymousCallRejectionCapAvailabilityEnum =
    (typeof AnonymousCallRejectionCapAvailabilityEnum)[keyof typeof AnonymousCallRejectionCapAvailabilityEnum];
export const AnonymousCallRejectionCapChangeableEnum = {
    CanModify: "CAN_MODIFY",
    ReadOnly: "READ_ONLY",
} as const;

export type AnonymousCallRejectionCapChangeableEnum = (typeof AnonymousCallRejectionCapChangeableEnum)[keyof typeof AnonymousCallRejectionCapChangeableEnum];
export const AnonymousCallRejectionCapPredefinableEnum = {
    Predefinable: "PREDEFINABLE",
    None: "NONE",
} as const;

export type AnonymousCallRejectionCapPredefinableEnum =
    (typeof AnonymousCallRejectionCapPredefinableEnum)[keyof typeof AnonymousCallRejectionCapPredefinableEnum];

/**
 *
 * @export
 * @interface AuthorizationCodeCap
 */
export interface AuthorizationCodeCap {
    /**
     *
     * @type {string}
     * @memberof AuthorizationCodeCap
     */
    availability?: AuthorizationCodeCapAvailabilityEnum;
    /**
     *
     * @type {string}
     * @memberof AuthorizationCodeCap
     */
    changeable?: AuthorizationCodeCapChangeableEnum;
    /**
     *
     * @type {string}
     * @memberof AuthorizationCodeCap
     */
    predefinable?: AuthorizationCodeCapPredefinableEnum;
}

export const AuthorizationCodeCapAvailabilityEnum = {
    Party: "PARTY",
    Puid: "PUID",
} as const;

export type AuthorizationCodeCapAvailabilityEnum = (typeof AuthorizationCodeCapAvailabilityEnum)[keyof typeof AuthorizationCodeCapAvailabilityEnum];
export const AuthorizationCodeCapChangeableEnum = {
    CanModify: "CAN_MODIFY",
    ReadOnly: "READ_ONLY",
} as const;

export type AuthorizationCodeCapChangeableEnum = (typeof AuthorizationCodeCapChangeableEnum)[keyof typeof AuthorizationCodeCapChangeableEnum];
export const AuthorizationCodeCapPredefinableEnum = {
    Predefinable: "PREDEFINABLE",
    None: "NONE",
} as const;

export type AuthorizationCodeCapPredefinableEnum = (typeof AuthorizationCodeCapPredefinableEnum)[keyof typeof AuthorizationCodeCapPredefinableEnum];

/**
 *
 * @export
 * @interface AutoAttendant
 */
export interface AutoAttendant {
    /**
     *
     * @type {string}
     * @memberof AutoAttendant
     */
    inherit?: AutoAttendantInheritEnum;
    /**
     *
     * @type {number}
     * @memberof AutoAttendant
     */
    rootVxmlFileId?: number;
    /**
     *
     * @type {string}
     * @memberof AutoAttendant
     */
    status?: AutoAttendantStatusEnum;
}

export const AutoAttendantInheritEnum = {
    Primary: "PRIMARY",
    Self: "SELF",
} as const;

export type AutoAttendantInheritEnum = (typeof AutoAttendantInheritEnum)[keyof typeof AutoAttendantInheritEnum];
export const AutoAttendantStatusEnum = {
    On: "ON",
    Off: "OFF",
} as const;

export type AutoAttendantStatusEnum = (typeof AutoAttendantStatusEnum)[keyof typeof AutoAttendantStatusEnum];

/**
 *
 * @export
 * @interface AutoAttendantCap
 */
export interface AutoAttendantCap {
    /**
     *
     * @type {string}
     * @memberof AutoAttendantCap
     */
    availability?: AutoAttendantCapAvailabilityEnum;
    /**
     *
     * @type {string}
     * @memberof AutoAttendantCap
     */
    changeable?: AutoAttendantCapChangeableEnum;
    /**
     *
     * @type {string}
     * @memberof AutoAttendantCap
     */
    licenseType?: AutoAttendantCapLicenseTypeEnum;
    /**
     *
     * @type {string}
     * @memberof AutoAttendantCap
     */
    predefinable?: AutoAttendantCapPredefinableEnum;
}

export const AutoAttendantCapAvailabilityEnum = {
    Party: "PARTY",
    Puid: "PUID",
} as const;

export type AutoAttendantCapAvailabilityEnum = (typeof AutoAttendantCapAvailabilityEnum)[keyof typeof AutoAttendantCapAvailabilityEnum];
export const AutoAttendantCapChangeableEnum = {
    CanModify: "CAN_MODIFY",
    ReadOnly: "READ_ONLY",
} as const;

export type AutoAttendantCapChangeableEnum = (typeof AutoAttendantCapChangeableEnum)[keyof typeof AutoAttendantCapChangeableEnum];
export const AutoAttendantCapLicenseTypeEnum = {
    Consumer: "CONSUMER",
    Deluxe: "DELUXE",
    Enterprise: "ENTERPRISE",
} as const;

export type AutoAttendantCapLicenseTypeEnum = (typeof AutoAttendantCapLicenseTypeEnum)[keyof typeof AutoAttendantCapLicenseTypeEnum];
export const AutoAttendantCapPredefinableEnum = {
    Predefinable: "PREDEFINABLE",
    None: "NONE",
} as const;

export type AutoAttendantCapPredefinableEnum = (typeof AutoAttendantCapPredefinableEnum)[keyof typeof AutoAttendantCapPredefinableEnum];

/**
 *
 * @export
 * @interface BearerBasedCallForwardingCap
 */
export interface BearerBasedCallForwardingCap {
    /**
     *
     * @type {string}
     * @memberof BearerBasedCallForwardingCap
     */
    availability?: BearerBasedCallForwardingCapAvailabilityEnum;
    /**
     *
     * @type {string}
     * @memberof BearerBasedCallForwardingCap
     */
    changeable?: BearerBasedCallForwardingCapChangeableEnum;
    /**
     *
     * @type {boolean}
     * @memberof BearerBasedCallForwardingCap
     */
    multiType?: boolean;
    /**
     *
     * @type {string}
     * @memberof BearerBasedCallForwardingCap
     */
    predefinable?: BearerBasedCallForwardingCapPredefinableEnum;
}

export const BearerBasedCallForwardingCapAvailabilityEnum = {
    Party: "PARTY",
    Puid: "PUID",
} as const;

export type BearerBasedCallForwardingCapAvailabilityEnum =
    (typeof BearerBasedCallForwardingCapAvailabilityEnum)[keyof typeof BearerBasedCallForwardingCapAvailabilityEnum];
export const BearerBasedCallForwardingCapChangeableEnum = {
    CanModify: "CAN_MODIFY",
    ReadOnly: "READ_ONLY",
} as const;

export type BearerBasedCallForwardingCapChangeableEnum =
    (typeof BearerBasedCallForwardingCapChangeableEnum)[keyof typeof BearerBasedCallForwardingCapChangeableEnum];
export const BearerBasedCallForwardingCapPredefinableEnum = {
    Predefinable: "PREDEFINABLE",
    None: "NONE",
} as const;

export type BearerBasedCallForwardingCapPredefinableEnum =
    (typeof BearerBasedCallForwardingCapPredefinableEnum)[keyof typeof BearerBasedCallForwardingCapPredefinableEnum];

/**
 *
 * @export
 * @interface BlockCallCompletionBusySubscriber
 */
export interface BlockCallCompletionBusySubscriber {
    /**
     *
     * @type {string}
     * @memberof BlockCallCompletionBusySubscriber
     */
    inherit?: BlockCallCompletionBusySubscriberInheritEnum;
    /**
     *
     * @type {string}
     * @memberof BlockCallCompletionBusySubscriber
     */
    status?: BlockCallCompletionBusySubscriberStatusEnum;
}

export const BlockCallCompletionBusySubscriberInheritEnum = {
    Primary: "PRIMARY",
    Self: "SELF",
} as const;

export type BlockCallCompletionBusySubscriberInheritEnum =
    (typeof BlockCallCompletionBusySubscriberInheritEnum)[keyof typeof BlockCallCompletionBusySubscriberInheritEnum];
export const BlockCallCompletionBusySubscriberStatusEnum = {
    On: "ON",
    Off: "OFF",
} as const;

export type BlockCallCompletionBusySubscriberStatusEnum =
    (typeof BlockCallCompletionBusySubscriberStatusEnum)[keyof typeof BlockCallCompletionBusySubscriberStatusEnum];

/**
 *
 * @export
 * @interface BlockCallCompletionBusySubscriberCap
 */
export interface BlockCallCompletionBusySubscriberCap {
    /**
     *
     * @type {string}
     * @memberof BlockCallCompletionBusySubscriberCap
     */
    availability?: BlockCallCompletionBusySubscriberCapAvailabilityEnum;
    /**
     *
     * @type {string}
     * @memberof BlockCallCompletionBusySubscriberCap
     */
    changeable?: BlockCallCompletionBusySubscriberCapChangeableEnum;
    /**
     *
     * @type {string}
     * @memberof BlockCallCompletionBusySubscriberCap
     */
    predefinable?: BlockCallCompletionBusySubscriberCapPredefinableEnum;
}

export const BlockCallCompletionBusySubscriberCapAvailabilityEnum = {
    Party: "PARTY",
    Puid: "PUID",
} as const;

export type BlockCallCompletionBusySubscriberCapAvailabilityEnum =
    (typeof BlockCallCompletionBusySubscriberCapAvailabilityEnum)[keyof typeof BlockCallCompletionBusySubscriberCapAvailabilityEnum];
export const BlockCallCompletionBusySubscriberCapChangeableEnum = {
    CanModify: "CAN_MODIFY",
    ReadOnly: "READ_ONLY",
} as const;

export type BlockCallCompletionBusySubscriberCapChangeableEnum =
    (typeof BlockCallCompletionBusySubscriberCapChangeableEnum)[keyof typeof BlockCallCompletionBusySubscriberCapChangeableEnum];
export const BlockCallCompletionBusySubscriberCapPredefinableEnum = {
    Predefinable: "PREDEFINABLE",
    None: "NONE",
} as const;

export type BlockCallCompletionBusySubscriberCapPredefinableEnum =
    (typeof BlockCallCompletionBusySubscriberCapPredefinableEnum)[keyof typeof BlockCallCompletionBusySubscriberCapPredefinableEnum];

/**
 *
 * @export
 * @interface BusyLampField
 */
export interface BusyLampField {
    /**
     *
     * @type {string}
     * @memberof BusyLampField
     */
    inherit?: BusyLampFieldInheritEnum;
    /**
     *
     * @type {string}
     * @memberof BusyLampField
     */
    status?: BusyLampFieldStatusEnum;
}

export const BusyLampFieldInheritEnum = {
    Primary: "PRIMARY",
    Self: "SELF",
} as const;

export type BusyLampFieldInheritEnum = (typeof BusyLampFieldInheritEnum)[keyof typeof BusyLampFieldInheritEnum];
export const BusyLampFieldStatusEnum = {
    On: "ON",
    Off: "OFF",
} as const;

export type BusyLampFieldStatusEnum = (typeof BusyLampFieldStatusEnum)[keyof typeof BusyLampFieldStatusEnum];

/**
 *
 * @export
 * @interface BusyLampFieldCap
 */
export interface BusyLampFieldCap {
    /**
     *
     * @type {string}
     * @memberof BusyLampFieldCap
     */
    availability?: BusyLampFieldCapAvailabilityEnum;
    /**
     *
     * @type {string}
     * @memberof BusyLampFieldCap
     */
    changeable?: BusyLampFieldCapChangeableEnum;
    /**
     *
     * @type {string}
     * @memberof BusyLampFieldCap
     */
    predefinable?: BusyLampFieldCapPredefinableEnum;
}

export const BusyLampFieldCapAvailabilityEnum = {
    Party: "PARTY",
    Puid: "PUID",
} as const;

export type BusyLampFieldCapAvailabilityEnum = (typeof BusyLampFieldCapAvailabilityEnum)[keyof typeof BusyLampFieldCapAvailabilityEnum];
export const BusyLampFieldCapChangeableEnum = {
    CanModify: "CAN_MODIFY",
    ReadOnly: "READ_ONLY",
} as const;

export type BusyLampFieldCapChangeableEnum = (typeof BusyLampFieldCapChangeableEnum)[keyof typeof BusyLampFieldCapChangeableEnum];
export const BusyLampFieldCapPredefinableEnum = {
    Predefinable: "PREDEFINABLE",
    None: "NONE",
} as const;

export type BusyLampFieldCapPredefinableEnum = (typeof BusyLampFieldCapPredefinableEnum)[keyof typeof BusyLampFieldCapPredefinableEnum];

/**
 *
 * @export
 * @interface CallBarring
 */
export interface CallBarring {
    /**
     *
     * @type {boolean}
     * @memberof CallBarring
     */
    allBarring?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarring
     */
    directoryAssistanceBarring?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarring
     */
    emergencyBarring?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarring
     */
    fgbDialedCarrierBarring?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarring
     */
    fgdDialedCarrierBarring?: boolean;
    /**
     *
     * @type {string}
     * @memberof CallBarring
     */
    inherit?: CallBarringInheritEnum;
    /**
     *
     * @type {boolean}
     * @memberof CallBarring
     */
    intExhc?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarring
     */
    interLataBarring?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarring
     */
    internationalBarring?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarring
     */
    intraLataBarring?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarring
     */
    localBarring?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarring
     */
    mobileBarring?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarring
     */
    nationalBarring?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarring
     */
    nonNumericBarring?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarring
     */
    nxxCallsBarring?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarring
     */
    premiumServicesBarring?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarring
     */
    roamNetwork?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarring
     */
    specialDialTone?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarring
     */
    tollFreeBarring?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarring
     */
    user10CallsBarring?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarring
     */
    user11CallsBarring?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarring
     */
    user12CallsBarring?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarring
     */
    user13CallsBarring?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarring
     */
    user1CallsBarring?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarring
     */
    user2CallsBarring?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarring
     */
    user3CallsBarring?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarring
     */
    user4CallsBarring?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarring
     */
    user5CallsBarring?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarring
     */
    user6CallsBarring?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarring
     */
    user7CallsBarring?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarring
     */
    user8CallsBarring?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarring
     */
    user9CallsBarring?: boolean;
}

export const CallBarringInheritEnum = {
    Primary: "PRIMARY",
    Self: "SELF",
} as const;

export type CallBarringInheritEnum = (typeof CallBarringInheritEnum)[keyof typeof CallBarringInheritEnum];

/**
 *
 * @export
 * @interface CallBarringCap
 */
export interface CallBarringCap {
    /**
     *
     * @type {boolean}
     * @memberof CallBarringCap
     */
    allControllable?: boolean;
    /**
     *
     * @type {string}
     * @memberof CallBarringCap
     */
    availability?: CallBarringCapAvailabilityEnum;
    /**
     *
     * @type {string}
     * @memberof CallBarringCap
     */
    changeable?: CallBarringCapChangeableEnum;
    /**
     *
     * @type {boolean}
     * @memberof CallBarringCap
     */
    directoryAssistanceControllable?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarringCap
     */
    emergencyControllable?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarringCap
     */
    fgbDialedCarrierControllable?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarringCap
     */
    fgdDialedCarrierControllable?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarringCap
     */
    intExhcControllable?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarringCap
     */
    interLataControllable?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarringCap
     */
    internationalControllable?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarringCap
     */
    intraLataControllable?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarringCap
     */
    localControllable?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarringCap
     */
    mobileControllable?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarringCap
     */
    nationalControllable?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarringCap
     */
    nonNumericControllable?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarringCap
     */
    nxxCallsControllable?: boolean;
    /**
     *
     * @type {string}
     * @memberof CallBarringCap
     */
    predefinable?: CallBarringCapPredefinableEnum;
    /**
     *
     * @type {boolean}
     * @memberof CallBarringCap
     */
    premiumServicesControllable?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarringCap
     */
    roamNetworkControllable?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarringCap
     */
    tollFreeControllable?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarringCap
     */
    user10CallsControllable?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarringCap
     */
    user11CallsControllable?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarringCap
     */
    user12CallsControllable?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarringCap
     */
    user13CallsControllable?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarringCap
     */
    user1CallsControllable?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarringCap
     */
    user2CallsControllable?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarringCap
     */
    user3CallsControllable?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarringCap
     */
    user4CallsControllable?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarringCap
     */
    user5CallsControllable?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarringCap
     */
    user6CallsControllable?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarringCap
     */
    user7CallsControllable?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarringCap
     */
    user8CallsControllable?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBarringCap
     */
    user9CallsControllable?: boolean;
}

export const CallBarringCapAvailabilityEnum = {
    Party: "PARTY",
    Puid: "PUID",
} as const;

export type CallBarringCapAvailabilityEnum = (typeof CallBarringCapAvailabilityEnum)[keyof typeof CallBarringCapAvailabilityEnum];
export const CallBarringCapChangeableEnum = {
    CanModify: "CAN_MODIFY",
    ReadOnly: "READ_ONLY",
} as const;

export type CallBarringCapChangeableEnum = (typeof CallBarringCapChangeableEnum)[keyof typeof CallBarringCapChangeableEnum];
export const CallBarringCapPredefinableEnum = {
    Predefinable: "PREDEFINABLE",
    None: "NONE",
} as const;

export type CallBarringCapPredefinableEnum = (typeof CallBarringCapPredefinableEnum)[keyof typeof CallBarringCapPredefinableEnum];

/**
 *
 * @export
 * @interface CallBlocking
 */
export interface CallBlocking {
    /**
     *
     * @type {boolean}
     * @memberof CallBlocking
     */
    blkAll?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBlocking
     */
    blkInternational?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBlocking
     */
    blockRoamNetwork?: boolean;
    /**
     *
     * @type {string}
     * @memberof CallBlocking
     */
    inherit?: CallBlockingInheritEnum;
    /**
     *
     * @type {boolean}
     * @memberof CallBlocking
     */
    roamOutsideCountry?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallBlocking
     */
    specialDialTone?: boolean;
}

export const CallBlockingInheritEnum = {
    Primary: "PRIMARY",
    Self: "SELF",
} as const;

export type CallBlockingInheritEnum = (typeof CallBlockingInheritEnum)[keyof typeof CallBlockingInheritEnum];

/**
 *
 * @export
 * @interface CallBlockingCap
 */
export interface CallBlockingCap {
    /**
     *
     * @type {boolean}
     * @memberof CallBlockingCap
     */
    allControllable?: boolean;
    /**
     *
     * @type {string}
     * @memberof CallBlockingCap
     */
    availability?: CallBlockingCapAvailabilityEnum;
    /**
     *
     * @type {boolean}
     * @memberof CallBlockingCap
     */
    blockRoamNetworkControllable?: boolean;
    /**
     *
     * @type {string}
     * @memberof CallBlockingCap
     */
    changeable?: CallBlockingCapChangeableEnum;
    /**
     *
     * @type {boolean}
     * @memberof CallBlockingCap
     */
    internationalControllable?: boolean;
    /**
     *
     * @type {string}
     * @memberof CallBlockingCap
     */
    predefinable?: CallBlockingCapPredefinableEnum;
    /**
     *
     * @type {boolean}
     * @memberof CallBlockingCap
     */
    roamOutsideCountryControllable?: boolean;
}

export const CallBlockingCapAvailabilityEnum = {
    Party: "PARTY",
    Puid: "PUID",
} as const;

export type CallBlockingCapAvailabilityEnum = (typeof CallBlockingCapAvailabilityEnum)[keyof typeof CallBlockingCapAvailabilityEnum];
export const CallBlockingCapChangeableEnum = {
    CanModify: "CAN_MODIFY",
    ReadOnly: "READ_ONLY",
} as const;

export type CallBlockingCapChangeableEnum = (typeof CallBlockingCapChangeableEnum)[keyof typeof CallBlockingCapChangeableEnum];
export const CallBlockingCapPredefinableEnum = {
    Predefinable: "PREDEFINABLE",
    None: "NONE",
} as const;

export type CallBlockingCapPredefinableEnum = (typeof CallBlockingCapPredefinableEnum)[keyof typeof CallBlockingCapPredefinableEnum];

/**
 *
 * @export
 * @interface CallCompletionBusySubscriberCap
 */
export interface CallCompletionBusySubscriberCap {
    /**
     *
     * @type {string}
     * @memberof CallCompletionBusySubscriberCap
     */
    availability?: CallCompletionBusySubscriberCapAvailabilityEnum;
    /**
     *
     * @type {string}
     * @memberof CallCompletionBusySubscriberCap
     */
    changeable?: CallCompletionBusySubscriberCapChangeableEnum;
    /**
     *
     * @type {string}
     * @memberof CallCompletionBusySubscriberCap
     */
    predefinable?: CallCompletionBusySubscriberCapPredefinableEnum;
}

export const CallCompletionBusySubscriberCapAvailabilityEnum = {
    Party: "PARTY",
    Puid: "PUID",
} as const;

export type CallCompletionBusySubscriberCapAvailabilityEnum =
    (typeof CallCompletionBusySubscriberCapAvailabilityEnum)[keyof typeof CallCompletionBusySubscriberCapAvailabilityEnum];
export const CallCompletionBusySubscriberCapChangeableEnum = {
    CanModify: "CAN_MODIFY",
    ReadOnly: "READ_ONLY",
} as const;

export type CallCompletionBusySubscriberCapChangeableEnum =
    (typeof CallCompletionBusySubscriberCapChangeableEnum)[keyof typeof CallCompletionBusySubscriberCapChangeableEnum];
export const CallCompletionBusySubscriberCapPredefinableEnum = {
    Predefinable: "PREDEFINABLE",
    None: "NONE",
} as const;

export type CallCompletionBusySubscriberCapPredefinableEnum =
    (typeof CallCompletionBusySubscriberCapPredefinableEnum)[keyof typeof CallCompletionBusySubscriberCapPredefinableEnum];

/**
 *
 * @export
 * @interface CallDeflection
 */
export interface CallDeflection {
    /**
     *
     * @type {string}
     * @memberof CallDeflection
     */
    fwdDN?: string;
    /**
     *
     * @type {string}
     * @memberof CallDeflection
     */
    fwdToType?: CallDeflectionFwdToTypeEnum;
    /**
     *
     * @type {string}
     * @memberof CallDeflection
     */
    inherit?: CallDeflectionInheritEnum;
    /**
     *
     * @type {boolean}
     * @memberof CallDeflection
     */
    restrictIdBackward?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallDeflection
     */
    restrictIdForward?: boolean;
    /**
     *
     * @type {string}
     * @memberof CallDeflection
     */
    tas181Mode?: CallDeflectionTas181ModeEnum;
}

export const CallDeflectionFwdToTypeEnum = {
    Dn: "TO_DN",
    Vms: "TO_VMS",
    Attnd: "TO_ATTND",
} as const;

export type CallDeflectionFwdToTypeEnum = (typeof CallDeflectionFwdToTypeEnum)[keyof typeof CallDeflectionFwdToTypeEnum];
export const CallDeflectionInheritEnum = {
    Primary: "PRIMARY",
    Self: "SELF",
} as const;

export type CallDeflectionInheritEnum = (typeof CallDeflectionInheritEnum)[keyof typeof CallDeflectionInheritEnum];
export const CallDeflectionTas181ModeEnum = {
    None: "TAS_181_NONE",
    NoFwinfo: "TAS_181_NO_FWINFO",
    WithFwinfo: "TAS_181_WITH_FWINFO",
} as const;

export type CallDeflectionTas181ModeEnum = (typeof CallDeflectionTas181ModeEnum)[keyof typeof CallDeflectionTas181ModeEnum];

/**
 *
 * @export
 * @interface CallDeflectionCap
 */
export interface CallDeflectionCap {
    /**
     *
     * @type {string}
     * @memberof CallDeflectionCap
     */
    availability?: CallDeflectionCapAvailabilityEnum;
    /**
     *
     * @type {string}
     * @memberof CallDeflectionCap
     */
    changeable?: CallDeflectionCapChangeableEnum;
    /**
     *
     * @type {string}
     * @memberof CallDeflectionCap
     */
    controlLevel?: CallDeflectionCapControlLevelEnum;
    /**
     *
     * @type {string}
     * @memberof CallDeflectionCap
     */
    predefinable?: CallDeflectionCapPredefinableEnum;
}

export const CallDeflectionCapAvailabilityEnum = {
    Party: "PARTY",
    Puid: "PUID",
} as const;

export type CallDeflectionCapAvailabilityEnum = (typeof CallDeflectionCapAvailabilityEnum)[keyof typeof CallDeflectionCapAvailabilityEnum];
export const CallDeflectionCapChangeableEnum = {
    CanModify: "CAN_MODIFY",
    ReadOnly: "READ_ONLY",
} as const;

export type CallDeflectionCapChangeableEnum = (typeof CallDeflectionCapChangeableEnum)[keyof typeof CallDeflectionCapChangeableEnum];
export const CallDeflectionCapControlLevelEnum = {
    Full: "EDIT_FULL",
    Partial: "EDIT_PARTIAL",
    None: "EDIT_NONE",
} as const;

export type CallDeflectionCapControlLevelEnum = (typeof CallDeflectionCapControlLevelEnum)[keyof typeof CallDeflectionCapControlLevelEnum];
export const CallDeflectionCapPredefinableEnum = {
    Predefinable: "PREDEFINABLE",
    None: "NONE",
} as const;

export type CallDeflectionCapPredefinableEnum = (typeof CallDeflectionCapPredefinableEnum)[keyof typeof CallDeflectionCapPredefinableEnum];

/**
 *
 * @export
 * @interface CallForwardingBusy
 */
export interface CallForwardingBusy {
    /**
     *
     * @type {boolean}
     * @memberof CallForwardingBusy
     */
    forwardDataCalls?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallForwardingBusy
     */
    forwardVoiceCalls?: boolean;
    /**
     *
     * @type {string}
     * @memberof CallForwardingBusy
     */
    fwdDN?: string;
    /**
     *
     * @type {string}
     * @memberof CallForwardingBusy
     */
    fwdDNDataCall?: string;
    /**
     *
     * @type {string}
     * @memberof CallForwardingBusy
     */
    fwdToType?: CallForwardingBusyFwdToTypeEnum;
    /**
     *
     * @type {string}
     * @memberof CallForwardingBusy
     */
    fwdToTypeDataCall?: CallForwardingBusyFwdToTypeDataCallEnum;
    /**
     *
     * @type {string}
     * @memberof CallForwardingBusy
     */
    inherit?: CallForwardingBusyInheritEnum;
    /**
     *
     * @type {boolean}
     * @memberof CallForwardingBusy
     */
    restrictIdBackward?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallForwardingBusy
     */
    restrictIdForward?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallForwardingBusy
     */
    specialDialTone?: boolean;
    /**
     *
     * @type {string}
     * @memberof CallForwardingBusy
     */
    status?: CallForwardingBusyStatusEnum;
    /**
     *
     * @type {string}
     * @memberof CallForwardingBusy
     */
    tas181Mode?: CallForwardingBusyTas181ModeEnum;
}

export const CallForwardingBusyFwdToTypeEnum = {
    Dn: "TO_DN",
    Vms: "TO_VMS",
    Attnd: "TO_ATTND",
} as const;

export type CallForwardingBusyFwdToTypeEnum = (typeof CallForwardingBusyFwdToTypeEnum)[keyof typeof CallForwardingBusyFwdToTypeEnum];
export const CallForwardingBusyFwdToTypeDataCallEnum = {
    UseVoice: "USE_VOICE",
    ToDn: "TO_DN",
    ToVms: "TO_VMS",
    ToAttnd: "TO_ATTND",
} as const;

export type CallForwardingBusyFwdToTypeDataCallEnum = (typeof CallForwardingBusyFwdToTypeDataCallEnum)[keyof typeof CallForwardingBusyFwdToTypeDataCallEnum];
export const CallForwardingBusyInheritEnum = {
    Primary: "PRIMARY",
    Self: "SELF",
} as const;

export type CallForwardingBusyInheritEnum = (typeof CallForwardingBusyInheritEnum)[keyof typeof CallForwardingBusyInheritEnum];
export const CallForwardingBusyStatusEnum = {
    On: "ON",
    Off: "OFF",
} as const;

export type CallForwardingBusyStatusEnum = (typeof CallForwardingBusyStatusEnum)[keyof typeof CallForwardingBusyStatusEnum];
export const CallForwardingBusyTas181ModeEnum = {
    None: "TAS_181_NONE",
    NoFwinfo: "TAS_181_NO_FWINFO",
    WithFwinfo: "TAS_181_WITH_FWINFO",
} as const;

export type CallForwardingBusyTas181ModeEnum = (typeof CallForwardingBusyTas181ModeEnum)[keyof typeof CallForwardingBusyTas181ModeEnum];

/**
 *
 * @export
 * @interface CallForwardingBusyCap
 */
export interface CallForwardingBusyCap {
    /**
     *
     * @type {string}
     * @memberof CallForwardingBusyCap
     */
    availability?: CallForwardingBusyCapAvailabilityEnum;
    /**
     *
     * @type {string}
     * @memberof CallForwardingBusyCap
     */
    changeable?: CallForwardingBusyCapChangeableEnum;
    /**
     *
     * @type {string}
     * @memberof CallForwardingBusyCap
     */
    controlLevel?: CallForwardingBusyCapControlLevelEnum;
    /**
     *
     * @type {string}
     * @memberof CallForwardingBusyCap
     */
    predefinable?: CallForwardingBusyCapPredefinableEnum;
}

export const CallForwardingBusyCapAvailabilityEnum = {
    Party: "PARTY",
    Puid: "PUID",
} as const;

export type CallForwardingBusyCapAvailabilityEnum = (typeof CallForwardingBusyCapAvailabilityEnum)[keyof typeof CallForwardingBusyCapAvailabilityEnum];
export const CallForwardingBusyCapChangeableEnum = {
    CanModify: "CAN_MODIFY",
    ReadOnly: "READ_ONLY",
} as const;

export type CallForwardingBusyCapChangeableEnum = (typeof CallForwardingBusyCapChangeableEnum)[keyof typeof CallForwardingBusyCapChangeableEnum];
export const CallForwardingBusyCapControlLevelEnum = {
    Full: "EDIT_FULL",
    Partial: "EDIT_PARTIAL",
    None: "EDIT_NONE",
} as const;

export type CallForwardingBusyCapControlLevelEnum = (typeof CallForwardingBusyCapControlLevelEnum)[keyof typeof CallForwardingBusyCapControlLevelEnum];
export const CallForwardingBusyCapPredefinableEnum = {
    Predefinable: "PREDEFINABLE",
    None: "NONE",
} as const;

export type CallForwardingBusyCapPredefinableEnum = (typeof CallForwardingBusyCapPredefinableEnum)[keyof typeof CallForwardingBusyCapPredefinableEnum];

/**
 *
 * @export
 * @interface CallForwardingDefault
 */
export interface CallForwardingDefault {
    /**
     *
     * @type {string}
     * @memberof CallForwardingDefault
     */
    busyActive?: CallForwardingDefaultBusyActiveEnum;
    /**
     *
     * @type {string}
     * @memberof CallForwardingDefault
     */
    fwdDN?: string;
    /**
     *
     * @type {string}
     * @memberof CallForwardingDefault
     */
    fwdToType?: CallForwardingDefaultFwdToTypeEnum;
    /**
     *
     * @type {string}
     * @memberof CallForwardingDefault
     */
    inherit?: CallForwardingDefaultInheritEnum;
    /**
     *
     * @type {number}
     * @memberof CallForwardingDefault
     */
    naTimeout?: number;
    /**
     *
     * @type {string}
     * @memberof CallForwardingDefault
     */
    noanswerActive?: CallForwardingDefaultNoanswerActiveEnum;
    /**
     *
     * @type {boolean}
     * @memberof CallForwardingDefault
     */
    restrictIdBackward?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallForwardingDefault
     */
    restrictIdForward?: boolean;
    /**
     *
     * @type {string}
     * @memberof CallForwardingDefault
     */
    tas181Mode?: CallForwardingDefaultTas181ModeEnum;
}

export const CallForwardingDefaultBusyActiveEnum = {
    On: "ON",
    Off: "OFF",
} as const;

export type CallForwardingDefaultBusyActiveEnum = (typeof CallForwardingDefaultBusyActiveEnum)[keyof typeof CallForwardingDefaultBusyActiveEnum];
export const CallForwardingDefaultFwdToTypeEnum = {
    Dn: "TO_DN",
    Vms: "TO_VMS",
    Attnd: "TO_ATTND",
} as const;

export type CallForwardingDefaultFwdToTypeEnum = (typeof CallForwardingDefaultFwdToTypeEnum)[keyof typeof CallForwardingDefaultFwdToTypeEnum];
export const CallForwardingDefaultInheritEnum = {
    Primary: "PRIMARY",
    Self: "SELF",
} as const;

export type CallForwardingDefaultInheritEnum = (typeof CallForwardingDefaultInheritEnum)[keyof typeof CallForwardingDefaultInheritEnum];
export const CallForwardingDefaultNoanswerActiveEnum = {
    On: "ON",
    Off: "OFF",
} as const;

export type CallForwardingDefaultNoanswerActiveEnum = (typeof CallForwardingDefaultNoanswerActiveEnum)[keyof typeof CallForwardingDefaultNoanswerActiveEnum];
export const CallForwardingDefaultTas181ModeEnum = {
    None: "TAS_181_NONE",
    NoFwinfo: "TAS_181_NO_FWINFO",
    WithFwinfo: "TAS_181_WITH_FWINFO",
} as const;

export type CallForwardingDefaultTas181ModeEnum = (typeof CallForwardingDefaultTas181ModeEnum)[keyof typeof CallForwardingDefaultTas181ModeEnum];

/**
 *
 * @export
 * @interface CallForwardingDefaultCap
 */
export interface CallForwardingDefaultCap {
    /**
     *
     * @type {string}
     * @memberof CallForwardingDefaultCap
     */
    availability?: CallForwardingDefaultCapAvailabilityEnum;
    /**
     *
     * @type {string}
     * @memberof CallForwardingDefaultCap
     */
    cfdMode?: CallForwardingDefaultCapCfdModeEnum;
    /**
     *
     * @type {string}
     * @memberof CallForwardingDefaultCap
     */
    changeable?: CallForwardingDefaultCapChangeableEnum;
    /**
     *
     * @type {string}
     * @memberof CallForwardingDefaultCap
     */
    controlLevel?: CallForwardingDefaultCapControlLevelEnum;
    /**
     *
     * @type {number}
     * @memberof CallForwardingDefaultCap
     */
    maxRange?: number;
    /**
     *
     * @type {number}
     * @memberof CallForwardingDefaultCap
     */
    minRange?: number;
    /**
     *
     * @type {string}
     * @memberof CallForwardingDefaultCap
     */
    noanswerControlLevel?: CallForwardingDefaultCapNoanswerControlLevelEnum;
    /**
     *
     * @type {string}
     * @memberof CallForwardingDefaultCap
     */
    predefinable?: CallForwardingDefaultCapPredefinableEnum;
}

export const CallForwardingDefaultCapAvailabilityEnum = {
    Party: "PARTY",
    Puid: "PUID",
} as const;

export type CallForwardingDefaultCapAvailabilityEnum = (typeof CallForwardingDefaultCapAvailabilityEnum)[keyof typeof CallForwardingDefaultCapAvailabilityEnum];
export const CallForwardingDefaultCapCfdModeEnum = {
    Standard: "STANDARD",
    BusyOnly: "BUSY_ONLY",
    NoanswerOnly: "NOANSWER_ONLY",
    BusyNoanswer: "BUSY_NOANSWER",
} as const;

export type CallForwardingDefaultCapCfdModeEnum = (typeof CallForwardingDefaultCapCfdModeEnum)[keyof typeof CallForwardingDefaultCapCfdModeEnum];
export const CallForwardingDefaultCapChangeableEnum = {
    CanModify: "CAN_MODIFY",
    ReadOnly: "READ_ONLY",
} as const;

export type CallForwardingDefaultCapChangeableEnum = (typeof CallForwardingDefaultCapChangeableEnum)[keyof typeof CallForwardingDefaultCapChangeableEnum];
export const CallForwardingDefaultCapControlLevelEnum = {
    Full: "EDIT_FULL",
    Partial: "EDIT_PARTIAL",
    None: "EDIT_NONE",
} as const;

export type CallForwardingDefaultCapControlLevelEnum = (typeof CallForwardingDefaultCapControlLevelEnum)[keyof typeof CallForwardingDefaultCapControlLevelEnum];
export const CallForwardingDefaultCapNoanswerControlLevelEnum = {
    Full: "EDIT_FULL",
    Partial: "EDIT_PARTIAL",
    None: "EDIT_NONE",
} as const;

export type CallForwardingDefaultCapNoanswerControlLevelEnum =
    (typeof CallForwardingDefaultCapNoanswerControlLevelEnum)[keyof typeof CallForwardingDefaultCapNoanswerControlLevelEnum];
export const CallForwardingDefaultCapPredefinableEnum = {
    Predefinable: "PREDEFINABLE",
    None: "NONE",
} as const;

export type CallForwardingDefaultCapPredefinableEnum = (typeof CallForwardingDefaultCapPredefinableEnum)[keyof typeof CallForwardingDefaultCapPredefinableEnum];

/**
 *
 * @export
 * @interface CallForwardingNoAnswer
 */
export interface CallForwardingNoAnswer {
    /**
     *
     * @type {boolean}
     * @memberof CallForwardingNoAnswer
     */
    forwardDataCalls?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallForwardingNoAnswer
     */
    forwardVoiceCalls?: boolean;
    /**
     *
     * @type {string}
     * @memberof CallForwardingNoAnswer
     */
    fwdDN?: string;
    /**
     *
     * @type {string}
     * @memberof CallForwardingNoAnswer
     */
    fwdDNDataCall?: string;
    /**
     *
     * @type {string}
     * @memberof CallForwardingNoAnswer
     */
    fwdToType?: CallForwardingNoAnswerFwdToTypeEnum;
    /**
     *
     * @type {string}
     * @memberof CallForwardingNoAnswer
     */
    fwdToTypeDataCall?: CallForwardingNoAnswerFwdToTypeDataCallEnum;
    /**
     *
     * @type {string}
     * @memberof CallForwardingNoAnswer
     */
    inherit?: CallForwardingNoAnswerInheritEnum;
    /**
     *
     * @type {number}
     * @memberof CallForwardingNoAnswer
     */
    naTimeout?: number;
    /**
     *
     * @type {boolean}
     * @memberof CallForwardingNoAnswer
     */
    restrictIdBackward?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallForwardingNoAnswer
     */
    restrictIdForward?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallForwardingNoAnswer
     */
    specialDialTone?: boolean;
    /**
     *
     * @type {string}
     * @memberof CallForwardingNoAnswer
     */
    status?: CallForwardingNoAnswerStatusEnum;
    /**
     *
     * @type {string}
     * @memberof CallForwardingNoAnswer
     */
    tas181Mode?: CallForwardingNoAnswerTas181ModeEnum;
}

export const CallForwardingNoAnswerFwdToTypeEnum = {
    Dn: "TO_DN",
    Vms: "TO_VMS",
    Attnd: "TO_ATTND",
} as const;

export type CallForwardingNoAnswerFwdToTypeEnum = (typeof CallForwardingNoAnswerFwdToTypeEnum)[keyof typeof CallForwardingNoAnswerFwdToTypeEnum];
export const CallForwardingNoAnswerFwdToTypeDataCallEnum = {
    UseVoice: "USE_VOICE",
    ToDn: "TO_DN",
    ToVms: "TO_VMS",
    ToAttnd: "TO_ATTND",
} as const;

export type CallForwardingNoAnswerFwdToTypeDataCallEnum =
    (typeof CallForwardingNoAnswerFwdToTypeDataCallEnum)[keyof typeof CallForwardingNoAnswerFwdToTypeDataCallEnum];
export const CallForwardingNoAnswerInheritEnum = {
    Primary: "PRIMARY",
    Self: "SELF",
} as const;

export type CallForwardingNoAnswerInheritEnum = (typeof CallForwardingNoAnswerInheritEnum)[keyof typeof CallForwardingNoAnswerInheritEnum];
export const CallForwardingNoAnswerStatusEnum = {
    On: "ON",
    Off: "OFF",
} as const;

export type CallForwardingNoAnswerStatusEnum = (typeof CallForwardingNoAnswerStatusEnum)[keyof typeof CallForwardingNoAnswerStatusEnum];
export const CallForwardingNoAnswerTas181ModeEnum = {
    None: "TAS_181_NONE",
    NoFwinfo: "TAS_181_NO_FWINFO",
    WithFwinfo: "TAS_181_WITH_FWINFO",
} as const;

export type CallForwardingNoAnswerTas181ModeEnum = (typeof CallForwardingNoAnswerTas181ModeEnum)[keyof typeof CallForwardingNoAnswerTas181ModeEnum];

/**
 *
 * @export
 * @interface CallForwardingNoAnswerCap
 */
export interface CallForwardingNoAnswerCap {
    /**
     *
     * @type {string}
     * @memberof CallForwardingNoAnswerCap
     */
    availability?: CallForwardingNoAnswerCapAvailabilityEnum;
    /**
     *
     * @type {string}
     * @memberof CallForwardingNoAnswerCap
     */
    changeable?: CallForwardingNoAnswerCapChangeableEnum;
    /**
     *
     * @type {string}
     * @memberof CallForwardingNoAnswerCap
     */
    controlLevel?: CallForwardingNoAnswerCapControlLevelEnum;
    /**
     *
     * @type {number}
     * @memberof CallForwardingNoAnswerCap
     */
    maxRange?: number;
    /**
     *
     * @type {number}
     * @memberof CallForwardingNoAnswerCap
     */
    minRange?: number;
    /**
     *
     * @type {string}
     * @memberof CallForwardingNoAnswerCap
     */
    predefinable?: CallForwardingNoAnswerCapPredefinableEnum;
}

export const CallForwardingNoAnswerCapAvailabilityEnum = {
    Party: "PARTY",
    Puid: "PUID",
} as const;

export type CallForwardingNoAnswerCapAvailabilityEnum =
    (typeof CallForwardingNoAnswerCapAvailabilityEnum)[keyof typeof CallForwardingNoAnswerCapAvailabilityEnum];
export const CallForwardingNoAnswerCapChangeableEnum = {
    CanModify: "CAN_MODIFY",
    ReadOnly: "READ_ONLY",
} as const;

export type CallForwardingNoAnswerCapChangeableEnum = (typeof CallForwardingNoAnswerCapChangeableEnum)[keyof typeof CallForwardingNoAnswerCapChangeableEnum];
export const CallForwardingNoAnswerCapControlLevelEnum = {
    Full: "EDIT_FULL",
    Partial: "EDIT_PARTIAL",
    None: "EDIT_NONE",
} as const;

export type CallForwardingNoAnswerCapControlLevelEnum =
    (typeof CallForwardingNoAnswerCapControlLevelEnum)[keyof typeof CallForwardingNoAnswerCapControlLevelEnum];
export const CallForwardingNoAnswerCapPredefinableEnum = {
    Predefinable: "PREDEFINABLE",
    None: "NONE",
} as const;

export type CallForwardingNoAnswerCapPredefinableEnum =
    (typeof CallForwardingNoAnswerCapPredefinableEnum)[keyof typeof CallForwardingNoAnswerCapPredefinableEnum];

/**
 *
 * @export
 * @interface CallForwardingNotReachable
 */
export interface CallForwardingNotReachable {
    /**
     *
     * @type {string}
     * @memberof CallForwardingNotReachable
     */
    fwdDN?: string;
    /**
     *
     * @type {string}
     * @memberof CallForwardingNotReachable
     */
    fwdToType?: CallForwardingNotReachableFwdToTypeEnum;
    /**
     *
     * @type {string}
     * @memberof CallForwardingNotReachable
     */
    inherit?: CallForwardingNotReachableInheritEnum;
    /**
     *
     * @type {boolean}
     * @memberof CallForwardingNotReachable
     */
    restrictIdBackward?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallForwardingNotReachable
     */
    restrictIdForward?: boolean;
    /**
     *
     * @type {string}
     * @memberof CallForwardingNotReachable
     */
    status?: CallForwardingNotReachableStatusEnum;
    /**
     *
     * @type {string}
     * @memberof CallForwardingNotReachable
     */
    tas181Mode?: CallForwardingNotReachableTas181ModeEnum;
}

export const CallForwardingNotReachableFwdToTypeEnum = {
    Dn: "TO_DN",
    Vms: "TO_VMS",
    Attnd: "TO_ATTND",
} as const;

export type CallForwardingNotReachableFwdToTypeEnum = (typeof CallForwardingNotReachableFwdToTypeEnum)[keyof typeof CallForwardingNotReachableFwdToTypeEnum];
export const CallForwardingNotReachableInheritEnum = {
    Primary: "PRIMARY",
    Self: "SELF",
} as const;

export type CallForwardingNotReachableInheritEnum = (typeof CallForwardingNotReachableInheritEnum)[keyof typeof CallForwardingNotReachableInheritEnum];
export const CallForwardingNotReachableStatusEnum = {
    On: "ON",
    Off: "OFF",
} as const;

export type CallForwardingNotReachableStatusEnum = (typeof CallForwardingNotReachableStatusEnum)[keyof typeof CallForwardingNotReachableStatusEnum];
export const CallForwardingNotReachableTas181ModeEnum = {
    None: "TAS_181_NONE",
    NoFwinfo: "TAS_181_NO_FWINFO",
    WithFwinfo: "TAS_181_WITH_FWINFO",
} as const;

export type CallForwardingNotReachableTas181ModeEnum = (typeof CallForwardingNotReachableTas181ModeEnum)[keyof typeof CallForwardingNotReachableTas181ModeEnum];

/**
 *
 * @export
 * @interface CallForwardingNotReachableCap
 */
export interface CallForwardingNotReachableCap {
    /**
     *
     * @type {string}
     * @memberof CallForwardingNotReachableCap
     */
    availability?: CallForwardingNotReachableCapAvailabilityEnum;
    /**
     *
     * @type {string}
     * @memberof CallForwardingNotReachableCap
     */
    changeable?: CallForwardingNotReachableCapChangeableEnum;
    /**
     *
     * @type {string}
     * @memberof CallForwardingNotReachableCap
     */
    controlLevel?: CallForwardingNotReachableCapControlLevelEnum;
    /**
     *
     * @type {string}
     * @memberof CallForwardingNotReachableCap
     */
    predefinable?: CallForwardingNotReachableCapPredefinableEnum;
}

export const CallForwardingNotReachableCapAvailabilityEnum = {
    Party: "PARTY",
    Puid: "PUID",
} as const;

export type CallForwardingNotReachableCapAvailabilityEnum =
    (typeof CallForwardingNotReachableCapAvailabilityEnum)[keyof typeof CallForwardingNotReachableCapAvailabilityEnum];
export const CallForwardingNotReachableCapChangeableEnum = {
    CanModify: "CAN_MODIFY",
    ReadOnly: "READ_ONLY",
} as const;

export type CallForwardingNotReachableCapChangeableEnum =
    (typeof CallForwardingNotReachableCapChangeableEnum)[keyof typeof CallForwardingNotReachableCapChangeableEnum];
export const CallForwardingNotReachableCapControlLevelEnum = {
    Full: "EDIT_FULL",
    Partial: "EDIT_PARTIAL",
    None: "EDIT_NONE",
} as const;

export type CallForwardingNotReachableCapControlLevelEnum =
    (typeof CallForwardingNotReachableCapControlLevelEnum)[keyof typeof CallForwardingNotReachableCapControlLevelEnum];
export const CallForwardingNotReachableCapPredefinableEnum = {
    Predefinable: "PREDEFINABLE",
    None: "NONE",
} as const;

export type CallForwardingNotReachableCapPredefinableEnum =
    (typeof CallForwardingNotReachableCapPredefinableEnum)[keyof typeof CallForwardingNotReachableCapPredefinableEnum];

/**
 *
 * @export
 * @interface CallForwardingUnregistered
 */
export interface CallForwardingUnregistered {
    /**
     *
     * @type {boolean}
     * @memberof CallForwardingUnregistered
     */
    forwardDataCalls?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallForwardingUnregistered
     */
    forwardVoiceCalls?: boolean;
    /**
     *
     * @type {string}
     * @memberof CallForwardingUnregistered
     */
    fwdDN?: string;
    /**
     *
     * @type {string}
     * @memberof CallForwardingUnregistered
     */
    fwdDNDataCall?: string;
    /**
     *
     * @type {string}
     * @memberof CallForwardingUnregistered
     */
    fwdToType?: CallForwardingUnregisteredFwdToTypeEnum;
    /**
     *
     * @type {string}
     * @memberof CallForwardingUnregistered
     */
    fwdToTypeDataCall?: CallForwardingUnregisteredFwdToTypeDataCallEnum;
    /**
     *
     * @type {string}
     * @memberof CallForwardingUnregistered
     */
    inherit?: CallForwardingUnregisteredInheritEnum;
    /**
     *
     * @type {boolean}
     * @memberof CallForwardingUnregistered
     */
    restrictIdBackward?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallForwardingUnregistered
     */
    restrictIdForward?: boolean;
    /**
     *
     * @type {string}
     * @memberof CallForwardingUnregistered
     */
    status?: CallForwardingUnregisteredStatusEnum;
    /**
     *
     * @type {string}
     * @memberof CallForwardingUnregistered
     */
    tas181Mode?: CallForwardingUnregisteredTas181ModeEnum;
}

export const CallForwardingUnregisteredFwdToTypeEnum = {
    Dn: "TO_DN",
    Vms: "TO_VMS",
    Attnd: "TO_ATTND",
} as const;

export type CallForwardingUnregisteredFwdToTypeEnum = (typeof CallForwardingUnregisteredFwdToTypeEnum)[keyof typeof CallForwardingUnregisteredFwdToTypeEnum];
export const CallForwardingUnregisteredFwdToTypeDataCallEnum = {
    UseVoice: "USE_VOICE",
    ToDn: "TO_DN",
    ToVms: "TO_VMS",
    ToAttnd: "TO_ATTND",
} as const;

export type CallForwardingUnregisteredFwdToTypeDataCallEnum =
    (typeof CallForwardingUnregisteredFwdToTypeDataCallEnum)[keyof typeof CallForwardingUnregisteredFwdToTypeDataCallEnum];
export const CallForwardingUnregisteredInheritEnum = {
    Primary: "PRIMARY",
    Self: "SELF",
} as const;

export type CallForwardingUnregisteredInheritEnum = (typeof CallForwardingUnregisteredInheritEnum)[keyof typeof CallForwardingUnregisteredInheritEnum];
export const CallForwardingUnregisteredStatusEnum = {
    On: "ON",
    Off: "OFF",
} as const;

export type CallForwardingUnregisteredStatusEnum = (typeof CallForwardingUnregisteredStatusEnum)[keyof typeof CallForwardingUnregisteredStatusEnum];
export const CallForwardingUnregisteredTas181ModeEnum = {
    None: "TAS_181_NONE",
    NoFwinfo: "TAS_181_NO_FWINFO",
    WithFwinfo: "TAS_181_WITH_FWINFO",
} as const;

export type CallForwardingUnregisteredTas181ModeEnum = (typeof CallForwardingUnregisteredTas181ModeEnum)[keyof typeof CallForwardingUnregisteredTas181ModeEnum];

/**
 *
 * @export
 * @interface CallForwardingUnregisteredCap
 */
export interface CallForwardingUnregisteredCap {
    /**
     *
     * @type {string}
     * @memberof CallForwardingUnregisteredCap
     */
    availability?: CallForwardingUnregisteredCapAvailabilityEnum;
    /**
     *
     * @type {string}
     * @memberof CallForwardingUnregisteredCap
     */
    changeable?: CallForwardingUnregisteredCapChangeableEnum;
    /**
     *
     * @type {string}
     * @memberof CallForwardingUnregisteredCap
     */
    controlLevel?: CallForwardingUnregisteredCapControlLevelEnum;
    /**
     *
     * @type {string}
     * @memberof CallForwardingUnregisteredCap
     */
    predefinable?: CallForwardingUnregisteredCapPredefinableEnum;
}

export const CallForwardingUnregisteredCapAvailabilityEnum = {
    Party: "PARTY",
    Puid: "PUID",
} as const;

export type CallForwardingUnregisteredCapAvailabilityEnum =
    (typeof CallForwardingUnregisteredCapAvailabilityEnum)[keyof typeof CallForwardingUnregisteredCapAvailabilityEnum];
export const CallForwardingUnregisteredCapChangeableEnum = {
    CanModify: "CAN_MODIFY",
    ReadOnly: "READ_ONLY",
} as const;

export type CallForwardingUnregisteredCapChangeableEnum =
    (typeof CallForwardingUnregisteredCapChangeableEnum)[keyof typeof CallForwardingUnregisteredCapChangeableEnum];
export const CallForwardingUnregisteredCapControlLevelEnum = {
    Full: "EDIT_FULL",
    Partial: "EDIT_PARTIAL",
    None: "EDIT_NONE",
} as const;

export type CallForwardingUnregisteredCapControlLevelEnum =
    (typeof CallForwardingUnregisteredCapControlLevelEnum)[keyof typeof CallForwardingUnregisteredCapControlLevelEnum];
export const CallForwardingUnregisteredCapPredefinableEnum = {
    Predefinable: "PREDEFINABLE",
    None: "NONE",
} as const;

export type CallForwardingUnregisteredCapPredefinableEnum =
    (typeof CallForwardingUnregisteredCapPredefinableEnum)[keyof typeof CallForwardingUnregisteredCapPredefinableEnum];

/**
 *
 * @export
 * @interface CallForwardingVariable
 */
export interface CallForwardingVariable {
    /**
     *
     * @type {boolean}
     * @memberof CallForwardingVariable
     */
    forwardDataCalls?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallForwardingVariable
     */
    forwardVoiceCalls?: boolean;
    /**
     *
     * @type {string}
     * @memberof CallForwardingVariable
     */
    fwdDN?: string;
    /**
     *
     * @type {string}
     * @memberof CallForwardingVariable
     */
    fwdDNDataCall?: string;
    /**
     *
     * @type {string}
     * @memberof CallForwardingVariable
     */
    fwdToType?: CallForwardingVariableFwdToTypeEnum;
    /**
     *
     * @type {string}
     * @memberof CallForwardingVariable
     */
    fwdToTypeDataCall?: CallForwardingVariableFwdToTypeDataCallEnum;
    /**
     *
     * @type {string}
     * @memberof CallForwardingVariable
     */
    inherit?: CallForwardingVariableInheritEnum;
    /**
     *
     * @type {boolean}
     * @memberof CallForwardingVariable
     */
    pingRing?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallForwardingVariable
     */
    restrictIdBackward?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallForwardingVariable
     */
    restrictIdForward?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallForwardingVariable
     */
    specialDialTone?: boolean;
    /**
     *
     * @type {string}
     * @memberof CallForwardingVariable
     */
    status?: CallForwardingVariableStatusEnum;
    /**
     *
     * @type {string}
     * @memberof CallForwardingVariable
     */
    tas181Mode?: CallForwardingVariableTas181ModeEnum;
}

export const CallForwardingVariableFwdToTypeEnum = {
    Dn: "TO_DN",
    Vms: "TO_VMS",
    Attnd: "TO_ATTND",
} as const;

export type CallForwardingVariableFwdToTypeEnum = (typeof CallForwardingVariableFwdToTypeEnum)[keyof typeof CallForwardingVariableFwdToTypeEnum];
export const CallForwardingVariableFwdToTypeDataCallEnum = {
    UseVoice: "USE_VOICE",
    ToDn: "TO_DN",
    ToVms: "TO_VMS",
    ToAttnd: "TO_ATTND",
} as const;

export type CallForwardingVariableFwdToTypeDataCallEnum =
    (typeof CallForwardingVariableFwdToTypeDataCallEnum)[keyof typeof CallForwardingVariableFwdToTypeDataCallEnum];
export const CallForwardingVariableInheritEnum = {
    Primary: "PRIMARY",
    Self: "SELF",
} as const;

export type CallForwardingVariableInheritEnum = (typeof CallForwardingVariableInheritEnum)[keyof typeof CallForwardingVariableInheritEnum];
export const CallForwardingVariableStatusEnum = {
    On: "ON",
    Off: "OFF",
} as const;

export type CallForwardingVariableStatusEnum = (typeof CallForwardingVariableStatusEnum)[keyof typeof CallForwardingVariableStatusEnum];
export const CallForwardingVariableTas181ModeEnum = {
    None: "TAS_181_NONE",
    NoFwinfo: "TAS_181_NO_FWINFO",
    WithFwinfo: "TAS_181_WITH_FWINFO",
} as const;

export type CallForwardingVariableTas181ModeEnum = (typeof CallForwardingVariableTas181ModeEnum)[keyof typeof CallForwardingVariableTas181ModeEnum];

/**
 *
 * @export
 * @interface CallForwardingVariableCap
 */
export interface CallForwardingVariableCap {
    /**
     *
     * @type {string}
     * @memberof CallForwardingVariableCap
     */
    availability?: CallForwardingVariableCapAvailabilityEnum;
    /**
     *
     * @type {string}
     * @memberof CallForwardingVariableCap
     */
    changeable?: CallForwardingVariableCapChangeableEnum;
    /**
     *
     * @type {string}
     * @memberof CallForwardingVariableCap
     */
    controlLevel?: CallForwardingVariableCapControlLevelEnum;
    /**
     *
     * @type {string}
     * @memberof CallForwardingVariableCap
     */
    predefinable?: CallForwardingVariableCapPredefinableEnum;
}

export const CallForwardingVariableCapAvailabilityEnum = {
    Party: "PARTY",
    Puid: "PUID",
} as const;

export type CallForwardingVariableCapAvailabilityEnum =
    (typeof CallForwardingVariableCapAvailabilityEnum)[keyof typeof CallForwardingVariableCapAvailabilityEnum];
export const CallForwardingVariableCapChangeableEnum = {
    CanModify: "CAN_MODIFY",
    ReadOnly: "READ_ONLY",
} as const;

export type CallForwardingVariableCapChangeableEnum = (typeof CallForwardingVariableCapChangeableEnum)[keyof typeof CallForwardingVariableCapChangeableEnum];
export const CallForwardingVariableCapControlLevelEnum = {
    Full: "EDIT_FULL",
    Partial: "EDIT_PARTIAL",
    None: "EDIT_NONE",
} as const;

export type CallForwardingVariableCapControlLevelEnum =
    (typeof CallForwardingVariableCapControlLevelEnum)[keyof typeof CallForwardingVariableCapControlLevelEnum];
export const CallForwardingVariableCapPredefinableEnum = {
    Predefinable: "PREDEFINABLE",
    None: "NONE",
} as const;

export type CallForwardingVariableCapPredefinableEnum =
    (typeof CallForwardingVariableCapPredefinableEnum)[keyof typeof CallForwardingVariableCapPredefinableEnum];

/**
 *
 * @export
 * @interface CallPickupTerminatingCap
 */
export interface CallPickupTerminatingCap {
    /**
     *
     * @type {string}
     * @memberof CallPickupTerminatingCap
     */
    availability?: CallPickupTerminatingCapAvailabilityEnum;
    /**
     *
     * @type {boolean}
     * @memberof CallPickupTerminatingCap
     */
    bargeInAllowed?: boolean;
    /**
     *
     * @type {string}
     * @memberof CallPickupTerminatingCap
     */
    changeable?: CallPickupTerminatingCapChangeableEnum;
    /**
     *
     * @type {boolean}
     * @memberof CallPickupTerminatingCap
     */
    directedAllowed?: boolean;
    /**
     *
     * @type {string}
     * @memberof CallPickupTerminatingCap
     */
    predefinable?: CallPickupTerminatingCapPredefinableEnum;
}

export const CallPickupTerminatingCapAvailabilityEnum = {
    Party: "PARTY",
    Puid: "PUID",
} as const;

export type CallPickupTerminatingCapAvailabilityEnum = (typeof CallPickupTerminatingCapAvailabilityEnum)[keyof typeof CallPickupTerminatingCapAvailabilityEnum];
export const CallPickupTerminatingCapChangeableEnum = {
    CanModify: "CAN_MODIFY",
    ReadOnly: "READ_ONLY",
} as const;

export type CallPickupTerminatingCapChangeableEnum = (typeof CallPickupTerminatingCapChangeableEnum)[keyof typeof CallPickupTerminatingCapChangeableEnum];
export const CallPickupTerminatingCapPredefinableEnum = {
    Predefinable: "PREDEFINABLE",
    None: "NONE",
} as const;

export type CallPickupTerminatingCapPredefinableEnum = (typeof CallPickupTerminatingCapPredefinableEnum)[keyof typeof CallPickupTerminatingCapPredefinableEnum];

/**
 *
 * @export
 * @interface CallTransferCap
 */
export interface CallTransferCap {
    /**
     *
     * @type {string}
     * @memberof CallTransferCap
     */
    availability?: CallTransferCapAvailabilityEnum;
    /**
     *
     * @type {string}
     * @memberof CallTransferCap
     */
    changeable?: CallTransferCapChangeableEnum;
    /**
     *
     * @type {string}
     * @memberof CallTransferCap
     */
    predefinable?: CallTransferCapPredefinableEnum;
    /**
     *
     * @type {boolean}
     * @memberof CallTransferCap
     */
    xferBlind2VmsAllowed?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallTransferCap
     */
    xferBlindAllowed?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallTransferCap
     */
    xferConsultAllowed?: boolean;
}

export const CallTransferCapAvailabilityEnum = {
    Party: "PARTY",
    Puid: "PUID",
} as const;

export type CallTransferCapAvailabilityEnum = (typeof CallTransferCapAvailabilityEnum)[keyof typeof CallTransferCapAvailabilityEnum];
export const CallTransferCapChangeableEnum = {
    CanModify: "CAN_MODIFY",
    ReadOnly: "READ_ONLY",
} as const;

export type CallTransferCapChangeableEnum = (typeof CallTransferCapChangeableEnum)[keyof typeof CallTransferCapChangeableEnum];
export const CallTransferCapPredefinableEnum = {
    Predefinable: "PREDEFINABLE",
    None: "NONE",
} as const;

export type CallTransferCapPredefinableEnum = (typeof CallTransferCapPredefinableEnum)[keyof typeof CallTransferCapPredefinableEnum];

/**
 *
 * @export
 * @interface CallWaiting
 */
export interface CallWaiting {
    /**
     *
     * @type {string}
     * @memberof CallWaiting
     */
    inherit?: CallWaitingInheritEnum;
    /**
     *
     * @type {string}
     * @memberof CallWaiting
     */
    status?: CallWaitingStatusEnum;
}

export const CallWaitingInheritEnum = {
    Primary: "PRIMARY",
    Self: "SELF",
} as const;

export type CallWaitingInheritEnum = (typeof CallWaitingInheritEnum)[keyof typeof CallWaitingInheritEnum];
export const CallWaitingStatusEnum = {
    On: "ON",
    Off: "OFF",
} as const;

export type CallWaitingStatusEnum = (typeof CallWaitingStatusEnum)[keyof typeof CallWaitingStatusEnum];

/**
 *
 * @export
 * @interface CallWaitingCap
 */
export interface CallWaitingCap {
    /**
     *
     * @type {string}
     * @memberof CallWaitingCap
     */
    availability?: CallWaitingCapAvailabilityEnum;
    /**
     *
     * @type {string}
     * @memberof CallWaitingCap
     */
    changeable?: CallWaitingCapChangeableEnum;
    /**
     *
     * @type {string}
     * @memberof CallWaitingCap
     */
    predefinable?: CallWaitingCapPredefinableEnum;
}

export const CallWaitingCapAvailabilityEnum = {
    Party: "PARTY",
    Puid: "PUID",
} as const;

export type CallWaitingCapAvailabilityEnum = (typeof CallWaitingCapAvailabilityEnum)[keyof typeof CallWaitingCapAvailabilityEnum];
export const CallWaitingCapChangeableEnum = {
    CanModify: "CAN_MODIFY",
    ReadOnly: "READ_ONLY",
} as const;

export type CallWaitingCapChangeableEnum = (typeof CallWaitingCapChangeableEnum)[keyof typeof CallWaitingCapChangeableEnum];
export const CallWaitingCapPredefinableEnum = {
    Predefinable: "PREDEFINABLE",
    None: "NONE",
} as const;

export type CallWaitingCapPredefinableEnum = (typeof CallWaitingCapPredefinableEnum)[keyof typeof CallWaitingCapPredefinableEnum];

/**
 *
 * @export
 * @interface CallingLineId
 */
export interface CallingLineId {
    /**
     *
     * @type {string}
     * @memberof CallingLineId
     */
    clirUntilTime?: string;
    /**
     *
     * @type {boolean}
     * @memberof CallingLineId
     */
    connectedLinePresentation?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallingLineId
     */
    connectedLineRestriction?: boolean;
    /**
     *
     * @type {string}
     * @memberof CallingLineId
     */
    inherit?: CallingLineIdInheritEnum;
    /**
     *
     * @type {boolean}
     * @memberof CallingLineId
     */
    lineIdPresentation?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallingLineId
     */
    namePresentation?: boolean;
    /**
     *
     * @type {string}
     * @memberof CallingLineId
     */
    restrictionType?: CallingLineIdRestrictionTypeEnum;
}

export const CallingLineIdInheritEnum = {
    Primary: "PRIMARY",
    Self: "SELF",
} as const;

export type CallingLineIdInheritEnum = (typeof CallingLineIdInheritEnum)[keyof typeof CallingLineIdInheritEnum];
export const CallingLineIdRestrictionTypeEnum = {
    Public: "PUBLIC",
    Private: "PRIVATE",
    PermPublic: "PERM_PUBLIC",
    PermPrivate: "PERM_PRIVATE",
} as const;

export type CallingLineIdRestrictionTypeEnum = (typeof CallingLineIdRestrictionTypeEnum)[keyof typeof CallingLineIdRestrictionTypeEnum];

/**
 *
 * @export
 * @interface CallingLineIdCap
 */
export interface CallingLineIdCap {
    /**
     *
     * @type {string}
     * @memberof CallingLineIdCap
     */
    availability?: CallingLineIdCapAvailabilityEnum;
    /**
     *
     * @type {boolean}
     * @memberof CallingLineIdCap
     */
    callingLineIDRestrictionOverride?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallingLineIdCap
     */
    callingLineIdRestrictionControllable?: boolean;
    /**
     *
     * @type {string}
     * @memberof CallingLineIdCap
     */
    changeable?: CallingLineIdCapChangeableEnum;
    /**
     *
     * @type {boolean}
     * @memberof CallingLineIdCap
     */
    connectedLineRestrictionControllable?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CallingLineIdCap
     */
    originatingLineIDPresentationControllable?: boolean;
    /**
     *
     * @type {string}
     * @memberof CallingLineIdCap
     */
    predefinable?: CallingLineIdCapPredefinableEnum;
}

export const CallingLineIdCapAvailabilityEnum = {
    Party: "PARTY",
    Puid: "PUID",
} as const;

export type CallingLineIdCapAvailabilityEnum = (typeof CallingLineIdCapAvailabilityEnum)[keyof typeof CallingLineIdCapAvailabilityEnum];
export const CallingLineIdCapChangeableEnum = {
    CanModify: "CAN_MODIFY",
    ReadOnly: "READ_ONLY",
} as const;

export type CallingLineIdCapChangeableEnum = (typeof CallingLineIdCapChangeableEnum)[keyof typeof CallingLineIdCapChangeableEnum];
export const CallingLineIdCapPredefinableEnum = {
    Predefinable: "PREDEFINABLE",
    None: "NONE",
} as const;

export type CallingLineIdCapPredefinableEnum = (typeof CallingLineIdCapPredefinableEnum)[keyof typeof CallingLineIdCapPredefinableEnum];

/**
 *
 * @export
 * @interface CommunicationCapabilities
 */
export interface CommunicationCapabilities {
    /**
     *
     * @type {AccountCodeCap}
     * @memberof CommunicationCapabilities
     */
    accountCode?: AccountCodeCap;
    /**
     *
     * @type {AnonymousCallRejectionCap}
     * @memberof CommunicationCapabilities
     */
    anonymousCallRejection?: AnonymousCallRejectionCap;
    /**
     *
     * @type {AuthorizationCodeCap}
     * @memberof CommunicationCapabilities
     */
    authorizationCode?: AuthorizationCodeCap;
    /**
     *
     * @type {AutoAttendantCap}
     * @memberof CommunicationCapabilities
     */
    autoAttendant?: AutoAttendantCap;
    /**
     *
     * @type {BearerBasedCallForwardingCap}
     * @memberof CommunicationCapabilities
     */
    bearerBasedCallForwarding?: BearerBasedCallForwardingCap;
    /**
     *
     * @type {BlockCallCompletionBusySubscriberCap}
     * @memberof CommunicationCapabilities
     */
    blockCallCompletionBusySubscriber?: BlockCallCompletionBusySubscriberCap;
    /**
     *
     * @type {BusyLampFieldCap}
     * @memberof CommunicationCapabilities
     */
    busyLampField?: BusyLampFieldCap;
    /**
     *
     * @type {CallBarringCap}
     * @memberof CommunicationCapabilities
     */
    callBarring?: CallBarringCap;
    /**
     *
     * @type {CallBlockingCap}
     * @memberof CommunicationCapabilities
     */
    callBlocking?: CallBlockingCap;
    /**
     *
     * @type {CallCompletionBusySubscriberCap}
     * @memberof CommunicationCapabilities
     */
    callCompletionBusySubscriber?: CallCompletionBusySubscriberCap;
    /**
     *
     * @type {CallDeflectionCap}
     * @memberof CommunicationCapabilities
     */
    callDeflection?: CallDeflectionCap;
    /**
     *
     * @type {CallForwardingBusyCap}
     * @memberof CommunicationCapabilities
     */
    callForwardingBusy?: CallForwardingBusyCap;
    /**
     *
     * @type {CallForwardingDefaultCap}
     * @memberof CommunicationCapabilities
     */
    callForwardingDefault?: CallForwardingDefaultCap;
    /**
     *
     * @type {CallForwardingNoAnswerCap}
     * @memberof CommunicationCapabilities
     */
    callForwardingNoAnswer?: CallForwardingNoAnswerCap;
    /**
     *
     * @type {CallForwardingNotReachableCap}
     * @memberof CommunicationCapabilities
     */
    callForwardingNotReachable?: CallForwardingNotReachableCap;
    /**
     *
     * @type {CallForwardingUnregisteredCap}
     * @memberof CommunicationCapabilities
     */
    callForwardingUnregistered?: CallForwardingUnregisteredCap;
    /**
     *
     * @type {CallForwardingVariableCap}
     * @memberof CommunicationCapabilities
     */
    callForwardingVariable?: CallForwardingVariableCap;
    /**
     *
     * @type {CallPickupTerminatingCap}
     * @memberof CommunicationCapabilities
     */
    callPickupTerminating?: CallPickupTerminatingCap;
    /**
     *
     * @type {CallTransferCap}
     * @memberof CommunicationCapabilities
     */
    callTransfer?: CallTransferCap;
    /**
     *
     * @type {CallWaitingCap}
     * @memberof CommunicationCapabilities
     */
    callWaiting?: CallWaitingCap;
    /**
     *
     * @type {CallingLineIdCap}
     * @memberof CommunicationCapabilities
     */
    callingLineId?: CallingLineIdCap;
    /**
     *
     * @type {ConferenceCallingCap}
     * @memberof CommunicationCapabilities
     */
    conferenceCalling?: ConferenceCallingCap;
    /**
     *
     * @type {CustomerOriginatedTraceCap}
     * @memberof CommunicationCapabilities
     */
    customerOriginatedTrace?: CustomerOriginatedTraceCap;
    /**
     *
     * @type {DnExtensionCap}
     * @memberof CommunicationCapabilities
     */
    dnExtension?: DnExtensionCap;
    /**
     *
     * @type {DoNotDisturbCap}
     * @memberof CommunicationCapabilities
     */
    doNotDisturb?: DoNotDisturbCap;
    /**
     *
     * @type {FlexibleCallingLineIdCap}
     * @memberof CommunicationCapabilities
     */
    flexibleCallingLineId?: FlexibleCallingLineIdCap;
    /**
     *
     * @type {HotlineWarmlineCap}
     * @memberof CommunicationCapabilities
     */
    hotlineWarmline?: HotlineWarmlineCap;
    /**
     *
     * @type {InhibitIncomingForwardedCap}
     * @memberof CommunicationCapabilities
     */
    inhibitIncomingForwarded?: InhibitIncomingForwardedCap;
    /**
     *
     * @type {LanguageSelectionCap}
     * @memberof CommunicationCapabilities
     */
    languageSelection?: LanguageSelectionCap;
    /**
     *
     * @type {MiRingbackCap}
     * @memberof CommunicationCapabilities
     */
    miRingback?: MiRingbackCap;
    /**
     *
     * @type {MultipleRingPatternCap}
     * @memberof CommunicationCapabilities
     */
    multipleRingPattern?: MultipleRingPatternCap;
    /**
     *
     * @type {MusicOnHoldCap}
     * @memberof CommunicationCapabilities
     */
    musicOnHold?: MusicOnHoldCap;
    /**
     *
     * @type {OneNumberCap}
     * @memberof CommunicationCapabilities
     */
    oneNumber?: OneNumberCap;
    /**
     *
     * @type {OutgoingCallBarringCap}
     * @memberof CommunicationCapabilities
     */
    outgoingCallBarring?: OutgoingCallBarringCap;
    /**
     *
     * @type {PersonalizedRingbackToneCap}
     * @memberof CommunicationCapabilities
     */
    personalizedRingbackTone?: PersonalizedRingbackToneCap;
    /**
     *
     * @type {PinServiceCap}
     * @memberof CommunicationCapabilities
     */
    pinService?: PinServiceCap;
    /**
     *
     * @type {string}
     * @memberof CommunicationCapabilities
     */
    primaryPuid?: string;
    /**
     *
     * @type {SelectiveCallAcceptanceCap}
     * @memberof CommunicationCapabilities
     */
    selectiveCallAcceptance?: SelectiveCallAcceptanceCap;
    /**
     *
     * @type {SelectiveCallForwardingCap}
     * @memberof CommunicationCapabilities
     */
    selectiveCallForwarding?: SelectiveCallForwardingCap;
    /**
     *
     * @type {SelectiveCallRejectionCap}
     * @memberof CommunicationCapabilities
     */
    selectiveCallRejection?: SelectiveCallRejectionCap;
    /**
     *
     * @type {SelectiveDistinctiveAlertingCap}
     * @memberof CommunicationCapabilities
     */
    selectiveDistinctiveAlerting?: SelectiveDistinctiveAlertingCap;
    /**
     *
     * @type {SequentialRingCap}
     * @memberof CommunicationCapabilities
     */
    sequentialRing?: SequentialRingCap;
    /**
     *
     * @type {SettingsScheduleCap}
     * @memberof CommunicationCapabilities
     */
    settingsSchedule?: SettingsScheduleCap;
    /**
     *
     * @type {SimultaneousRingCap}
     * @memberof CommunicationCapabilities
     */
    simultaneousRing?: SimultaneousRingCap;
    /**
     *
     * @type {SpeedDial100Cap}
     * @memberof CommunicationCapabilities
     */
    speedDial100?: SpeedDial100Cap;
    /**
     *
     * @type {SpeedDial8Cap}
     * @memberof CommunicationCapabilities
     */
    speedDial8?: SpeedDial8Cap;
    /**
     *
     * @type {TimeOriginatedRCCap}
     * @memberof CommunicationCapabilities
     */
    timeOriginatedRC?: TimeOriginatedRCCap;
    /**
     *
     * @type {VddCap}
     * @memberof CommunicationCapabilities
     */
    vdd?: VddCap;
    /**
     *
     * @type {VoiceMailCap}
     * @memberof CommunicationCapabilities
     */
    voiceMail?: VoiceMailCap;
}
/**
 *
 * @export
 * @interface CommunicationSettings
 */
export interface CommunicationSettings {
    /**
     *
     * @type {AnonymousCallRejection}
     * @memberof CommunicationSettings
     */
    anonymousCallRejection?: AnonymousCallRejection;
    /**
     *
     * @type {AutoAttendant}
     * @memberof CommunicationSettings
     */
    autoAttendant?: AutoAttendant;
    /**
     *
     * @type {BlockCallCompletionBusySubscriber}
     * @memberof CommunicationSettings
     */
    blockCallCompletionBusySubscriber?: BlockCallCompletionBusySubscriber;
    /**
     *
     * @type {BusyLampField}
     * @memberof CommunicationSettings
     */
    busyLampField?: BusyLampField;
    /**
     *
     * @type {CallBarring}
     * @memberof CommunicationSettings
     */
    callBarring?: CallBarring;
    /**
     *
     * @type {CallBlocking}
     * @memberof CommunicationSettings
     */
    callBlocking?: CallBlocking;
    /**
     *
     * @type {CallDeflection}
     * @memberof CommunicationSettings
     */
    callDeflection?: CallDeflection;
    /**
     *
     * @type {CallForwardingBusy}
     * @memberof CommunicationSettings
     */
    callForwardingBusy?: CallForwardingBusy;
    /**
     *
     * @type {CallForwardingDefault}
     * @memberof CommunicationSettings
     */
    callForwardingDefault?: CallForwardingDefault;
    /**
     *
     * @type {CallForwardingNoAnswer}
     * @memberof CommunicationSettings
     */
    callForwardingNoAnswer?: CallForwardingNoAnswer;
    /**
     *
     * @type {CallForwardingNotReachable}
     * @memberof CommunicationSettings
     */
    callForwardingNotReachable?: CallForwardingNotReachable;
    /**
     *
     * @type {CallForwardingUnregistered}
     * @memberof CommunicationSettings
     */
    callForwardingUnregistered?: CallForwardingUnregistered;
    /**
     *
     * @type {CallForwardingVariable}
     * @memberof CommunicationSettings
     */
    callForwardingVariable?: CallForwardingVariable;
    /**
     *
     * @type {CallWaiting}
     * @memberof CommunicationSettings
     */
    callWaiting?: CallWaiting;
    /**
     *
     * @type {CallingLineId}
     * @memberof CommunicationSettings
     */
    callingLineId?: CallingLineId;
    /**
     *
     * @type {DNExtension}
     * @memberof CommunicationSettings
     */
    dnExtension?: DNExtension;
    /**
     *
     * @type {DoNotDisturb}
     * @memberof CommunicationSettings
     */
    doNotDisturb?: DoNotDisturb;
    /**
     *
     * @type {FlexibleCallingLineId}
     * @memberof CommunicationSettings
     */
    flexibleCallingLineID?: FlexibleCallingLineId;
    /**
     *
     * @type {HotlineWarmline}
     * @memberof CommunicationSettings
     */
    hotlineWarmline?: HotlineWarmline;
    /**
     *
     * @type {InhibitIncomingForwarded}
     * @memberof CommunicationSettings
     */
    inhibitIncomingForwarded?: InhibitIncomingForwarded;
    /**
     *
     * @type {LanguageSelection}
     * @memberof CommunicationSettings
     */
    languageSelection?: LanguageSelection;
    /**
     *
     * @type {MiRingBack}
     * @memberof CommunicationSettings
     */
    miRingback?: MiRingBack;
    /**
     *
     * @type {MultipleRingPattern}
     * @memberof CommunicationSettings
     */
    multipleRingPattern?: MultipleRingPattern;
    /**
     *
     * @type {MusicOnHold}
     * @memberof CommunicationSettings
     */
    musicOnHold?: MusicOnHold;
    /**
     *
     * @type {OutgoingCallBarring}
     * @memberof CommunicationSettings
     */
    outgoingCallBarring?: OutgoingCallBarring;
    /**
     *
     * @type {PersonalizedRingbackTone}
     * @memberof CommunicationSettings
     */
    personalizedRingbackTone?: PersonalizedRingbackTone;
    /**
     *
     * @type {PinService}
     * @memberof CommunicationSettings
     */
    pinService?: PinService;
    /**
     *
     * @type {SelectiveCallAcceptance}
     * @memberof CommunicationSettings
     */
    selectiveCallAcceptance?: SelectiveCallAcceptance;
    /**
     *
     * @type {SelectiveCallForwarding}
     * @memberof CommunicationSettings
     */
    selectiveCallForwarding?: SelectiveCallForwarding;
    /**
     *
     * @type {SelectiveCallRejection}
     * @memberof CommunicationSettings
     */
    selectiveCallRejection?: SelectiveCallRejection;
    /**
     *
     * @type {SelectiveDistinctiveAlerting}
     * @memberof CommunicationSettings
     */
    selectiveDistinctiveAlerting?: SelectiveDistinctiveAlerting;
    /**
     *
     * @type {SequentialRing}
     * @memberof CommunicationSettings
     */
    sequentialRing?: SequentialRing;
    /**
     *
     * @type {SimultaneousRing}
     * @memberof CommunicationSettings
     */
    simultaneousRing?: SimultaneousRing;
    /**
     *
     * @type {SpeedDial100}
     * @memberof CommunicationSettings
     */
    speedDial100?: SpeedDial100;
    /**
     *
     * @type {SpeedDial8}
     * @memberof CommunicationSettings
     */
    speedDial8?: SpeedDial8;
    /**
     *
     * @type {TimeZone}
     * @memberof CommunicationSettings
     */
    timeZone?: TimeZone;
    /**
     *
     * @type {Vdd}
     * @memberof CommunicationSettings
     */
    vdd?: Vdd;
}
/**
 *
 * @export
 * @interface ConferenceCallingCap
 */
export interface ConferenceCallingCap {
    /**
     *
     * @type {string}
     * @memberof ConferenceCallingCap
     */
    availability?: ConferenceCallingCapAvailabilityEnum;
    /**
     *
     * @type {string}
     * @memberof ConferenceCallingCap
     */
    changeable?: ConferenceCallingCapChangeableEnum;
    /**
     *
     * @type {number}
     * @memberof ConferenceCallingCap
     */
    nway?: number;
    /**
     *
     * @type {string}
     * @memberof ConferenceCallingCap
     */
    predefinable?: ConferenceCallingCapPredefinableEnum;
    /**
     *
     * @type {boolean}
     * @memberof ConferenceCallingCap
     */
    xferable?: boolean;
}

export const ConferenceCallingCapAvailabilityEnum = {
    Party: "PARTY",
    Puid: "PUID",
} as const;

export type ConferenceCallingCapAvailabilityEnum = (typeof ConferenceCallingCapAvailabilityEnum)[keyof typeof ConferenceCallingCapAvailabilityEnum];
export const ConferenceCallingCapChangeableEnum = {
    CanModify: "CAN_MODIFY",
    ReadOnly: "READ_ONLY",
} as const;

export type ConferenceCallingCapChangeableEnum = (typeof ConferenceCallingCapChangeableEnum)[keyof typeof ConferenceCallingCapChangeableEnum];
export const ConferenceCallingCapPredefinableEnum = {
    Predefinable: "PREDEFINABLE",
    None: "NONE",
} as const;

export type ConferenceCallingCapPredefinableEnum = (typeof ConferenceCallingCapPredefinableEnum)[keyof typeof ConferenceCallingCapPredefinableEnum];

/**
 *
 * @export
 * @interface CustomerOriginatedTraceCap
 */
export interface CustomerOriginatedTraceCap {
    /**
     *
     * @type {string}
     * @memberof CustomerOriginatedTraceCap
     */
    availability?: CustomerOriginatedTraceCapAvailabilityEnum;
    /**
     *
     * @type {string}
     * @memberof CustomerOriginatedTraceCap
     */
    changeable?: CustomerOriginatedTraceCapChangeableEnum;
    /**
     *
     * @type {string}
     * @memberof CustomerOriginatedTraceCap
     */
    predefinable?: CustomerOriginatedTraceCapPredefinableEnum;
}

export const CustomerOriginatedTraceCapAvailabilityEnum = {
    Party: "PARTY",
    Puid: "PUID",
} as const;

export type CustomerOriginatedTraceCapAvailabilityEnum =
    (typeof CustomerOriginatedTraceCapAvailabilityEnum)[keyof typeof CustomerOriginatedTraceCapAvailabilityEnum];
export const CustomerOriginatedTraceCapChangeableEnum = {
    CanModify: "CAN_MODIFY",
    ReadOnly: "READ_ONLY",
} as const;

export type CustomerOriginatedTraceCapChangeableEnum = (typeof CustomerOriginatedTraceCapChangeableEnum)[keyof typeof CustomerOriginatedTraceCapChangeableEnum];
export const CustomerOriginatedTraceCapPredefinableEnum = {
    Predefinable: "PREDEFINABLE",
    None: "NONE",
} as const;

export type CustomerOriginatedTraceCapPredefinableEnum =
    (typeof CustomerOriginatedTraceCapPredefinableEnum)[keyof typeof CustomerOriginatedTraceCapPredefinableEnum];

/**
 *
 * @export
 * @interface DNExtension
 */
export interface DNExtension {
    /**
     *
     * @type {Array<ExtensionEntry>}
     * @memberof DNExtension
     */
    dnExtLists?: Array<ExtensionEntry>;
    /**
     *
     * @type {boolean}
     * @memberof DNExtension
     */
    vmflag?: boolean;
}
/**
 *
 * @export
 * @interface DnExtensionCap
 */
export interface DnExtensionCap {
    /**
     *
     * @type {number}
     * @memberof DnExtensionCap
     */
    allowedEntries?: number;
    /**
     *
     * @type {string}
     * @memberof DnExtensionCap
     */
    availability?: DnExtensionCapAvailabilityEnum;
    /**
     *
     * @type {string}
     * @memberof DnExtensionCap
     */
    changeable?: DnExtensionCapChangeableEnum;
    /**
     *
     * @type {string}
     * @memberof DnExtensionCap
     */
    predefinable?: DnExtensionCapPredefinableEnum;
}

export const DnExtensionCapAvailabilityEnum = {
    Party: "PARTY",
    Puid: "PUID",
} as const;

export type DnExtensionCapAvailabilityEnum = (typeof DnExtensionCapAvailabilityEnum)[keyof typeof DnExtensionCapAvailabilityEnum];
export const DnExtensionCapChangeableEnum = {
    CanModify: "CAN_MODIFY",
    ReadOnly: "READ_ONLY",
} as const;

export type DnExtensionCapChangeableEnum = (typeof DnExtensionCapChangeableEnum)[keyof typeof DnExtensionCapChangeableEnum];
export const DnExtensionCapPredefinableEnum = {
    Predefinable: "PREDEFINABLE",
    None: "NONE",
} as const;

export type DnExtensionCapPredefinableEnum = (typeof DnExtensionCapPredefinableEnum)[keyof typeof DnExtensionCapPredefinableEnum];

/**
 *
 * @export
 * @interface DoNotDisturb
 */
export interface DoNotDisturb {
    /**
     *
     * @type {string}
     * @memberof DoNotDisturb
     */
    callHandling?: DoNotDisturbCallHandlingEnum;
    /**
     *
     * @type {string}
     * @memberof DoNotDisturb
     */
    inherit?: DoNotDisturbInheritEnum;
    /**
     *
     * @type {boolean}
     * @memberof DoNotDisturb
     */
    pingRing?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof DoNotDisturb
     */
    playAnnouncement?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof DoNotDisturb
     */
    specialDialTone?: boolean;
    /**
     *
     * @type {string}
     * @memberof DoNotDisturb
     */
    status?: DoNotDisturbStatusEnum;
}

export const DoNotDisturbCallHandlingEnum = {
    Busy: "DND_BUSY",
    FwdVm: "DND_FWD_VM",
} as const;

export type DoNotDisturbCallHandlingEnum = (typeof DoNotDisturbCallHandlingEnum)[keyof typeof DoNotDisturbCallHandlingEnum];
export const DoNotDisturbInheritEnum = {
    Primary: "PRIMARY",
    Self: "SELF",
} as const;

export type DoNotDisturbInheritEnum = (typeof DoNotDisturbInheritEnum)[keyof typeof DoNotDisturbInheritEnum];
export const DoNotDisturbStatusEnum = {
    On: "ON",
    Off: "OFF",
} as const;

export type DoNotDisturbStatusEnum = (typeof DoNotDisturbStatusEnum)[keyof typeof DoNotDisturbStatusEnum];

/**
 *
 * @export
 * @interface DoNotDisturbCap
 */
export interface DoNotDisturbCap {
    /**
     *
     * @type {boolean}
     * @memberof DoNotDisturbCap
     */
    allowUserForward?: boolean;
    /**
     *
     * @type {string}
     * @memberof DoNotDisturbCap
     */
    availability?: DoNotDisturbCapAvailabilityEnum;
    /**
     *
     * @type {string}
     * @memberof DoNotDisturbCap
     */
    changeable?: DoNotDisturbCapChangeableEnum;
    /**
     *
     * @type {string}
     * @memberof DoNotDisturbCap
     */
    predefinable?: DoNotDisturbCapPredefinableEnum;
    /**
     *
     * @type {boolean}
     * @memberof DoNotDisturbCap
     */
    userControlAnnouncement?: boolean;
}

export const DoNotDisturbCapAvailabilityEnum = {
    Party: "PARTY",
    Puid: "PUID",
} as const;

export type DoNotDisturbCapAvailabilityEnum = (typeof DoNotDisturbCapAvailabilityEnum)[keyof typeof DoNotDisturbCapAvailabilityEnum];
export const DoNotDisturbCapChangeableEnum = {
    CanModify: "CAN_MODIFY",
    ReadOnly: "READ_ONLY",
} as const;

export type DoNotDisturbCapChangeableEnum = (typeof DoNotDisturbCapChangeableEnum)[keyof typeof DoNotDisturbCapChangeableEnum];
export const DoNotDisturbCapPredefinableEnum = {
    Predefinable: "PREDEFINABLE",
    None: "NONE",
} as const;

export type DoNotDisturbCapPredefinableEnum = (typeof DoNotDisturbCapPredefinableEnum)[keyof typeof DoNotDisturbCapPredefinableEnum];

/**
 *
 * @export
 * @interface ExtensionEntry
 */
export interface ExtensionEntry {
    /**
     *
     * @type {boolean}
     * @memberof ExtensionEntry
     */
    alertExt?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof ExtensionEntry
     */
    ansConfirm?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof ExtensionEntry
     */
    bridgeAccess?: boolean;
    /**
     *
     * @type {string}
     * @memberof ExtensionEntry
     */
    extDN?: string;
    /**
     *
     * @type {string}
     * @memberof ExtensionEntry
     */
    extType?: ExtensionEntryExtTypeEnum;
    /**
     *
     * @type {boolean}
     * @memberof ExtensionEntry
     */
    pinRequired?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof ExtensionEntry
     */
    preservePAID?: boolean;
}

export const ExtensionEntryExtTypeEnum = {
    DeviceExt: "DEVICE_EXT",
    DnExt: "DN_EXT",
    DmhExt: "DMH_EXT",
} as const;

export type ExtensionEntryExtTypeEnum = (typeof ExtensionEntryExtTypeEnum)[keyof typeof ExtensionEntryExtTypeEnum];

/**
 *
 * @export
 * @interface FlexibleCallingLineId
 */
export interface FlexibleCallingLineId {
    /**
     *
     * @type {string}
     * @memberof FlexibleCallingLineId
     */
    inherit?: FlexibleCallingLineIdInheritEnum;
    /**
     *
     * @type {string}
     * @memberof FlexibleCallingLineId
     */
    status?: FlexibleCallingLineIdStatusEnum;
}

export const FlexibleCallingLineIdInheritEnum = {
    Primary: "PRIMARY",
    Self: "SELF",
} as const;

export type FlexibleCallingLineIdInheritEnum = (typeof FlexibleCallingLineIdInheritEnum)[keyof typeof FlexibleCallingLineIdInheritEnum];
export const FlexibleCallingLineIdStatusEnum = {
    On: "ON",
    Off: "OFF",
} as const;

export type FlexibleCallingLineIdStatusEnum = (typeof FlexibleCallingLineIdStatusEnum)[keyof typeof FlexibleCallingLineIdStatusEnum];

/**
 *
 * @export
 * @interface FlexibleCallingLineIdCap
 */
export interface FlexibleCallingLineIdCap {
    /**
     *
     * @type {string}
     * @memberof FlexibleCallingLineIdCap
     */
    availability?: FlexibleCallingLineIdCapAvailabilityEnum;
    /**
     *
     * @type {string}
     * @memberof FlexibleCallingLineIdCap
     */
    changeable?: FlexibleCallingLineIdCapChangeableEnum;
    /**
     *
     * @type {string}
     * @memberof FlexibleCallingLineIdCap
     */
    predefinable?: FlexibleCallingLineIdCapPredefinableEnum;
}

export const FlexibleCallingLineIdCapAvailabilityEnum = {
    Party: "PARTY",
    Puid: "PUID",
} as const;

export type FlexibleCallingLineIdCapAvailabilityEnum = (typeof FlexibleCallingLineIdCapAvailabilityEnum)[keyof typeof FlexibleCallingLineIdCapAvailabilityEnum];
export const FlexibleCallingLineIdCapChangeableEnum = {
    CanModify: "CAN_MODIFY",
    ReadOnly: "READ_ONLY",
} as const;

export type FlexibleCallingLineIdCapChangeableEnum = (typeof FlexibleCallingLineIdCapChangeableEnum)[keyof typeof FlexibleCallingLineIdCapChangeableEnum];
export const FlexibleCallingLineIdCapPredefinableEnum = {
    Predefinable: "PREDEFINABLE",
    None: "NONE",
} as const;

export type FlexibleCallingLineIdCapPredefinableEnum = (typeof FlexibleCallingLineIdCapPredefinableEnum)[keyof typeof FlexibleCallingLineIdCapPredefinableEnum];

/**
 *
 * @export
 * @interface HotLineType
 */
export interface HotLineType {
    /**
     *
     * @type {boolean}
     * @memberof HotLineType
     */
    acceptDights?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof HotLineType
     */
    isHotLine?: boolean;
}
/**
 *
 * @export
 * @interface HotlineWarmline
 */
export interface HotlineWarmline {
    /**
     *
     * @type {string}
     * @memberof HotlineWarmline
     */
    fwdDN?: string;
    /**
     *
     * @type {string}
     * @memberof HotlineWarmline
     */
    inherit?: HotlineWarmlineInheritEnum;
    /**
     *
     * @type {string}
     * @memberof HotlineWarmline
     */
    status?: HotlineWarmlineStatusEnum;
}

export const HotlineWarmlineInheritEnum = {
    Primary: "PRIMARY",
    Self: "SELF",
} as const;

export type HotlineWarmlineInheritEnum = (typeof HotlineWarmlineInheritEnum)[keyof typeof HotlineWarmlineInheritEnum];
export const HotlineWarmlineStatusEnum = {
    On: "ON",
    Off: "OFF",
} as const;

export type HotlineWarmlineStatusEnum = (typeof HotlineWarmlineStatusEnum)[keyof typeof HotlineWarmlineStatusEnum];

/**
 *
 * @export
 * @interface HotlineWarmlineCap
 */
export interface HotlineWarmlineCap {
    /**
     *
     * @type {string}
     * @memberof HotlineWarmlineCap
     */
    availability?: HotlineWarmlineCapAvailabilityEnum;
    /**
     *
     * @type {string}
     * @memberof HotlineWarmlineCap
     */
    changeable?: HotlineWarmlineCapChangeableEnum;
    /**
     *
     * @type {HotLineType}
     * @memberof HotlineWarmlineCap
     */
    hotLine?: HotLineType;
    /**
     *
     * @type {string}
     * @memberof HotlineWarmlineCap
     */
    predefinable?: HotlineWarmlineCapPredefinableEnum;
    /**
     *
     * @type {WarmLineType}
     * @memberof HotlineWarmlineCap
     */
    warmLine?: WarmLineType;
}

export const HotlineWarmlineCapAvailabilityEnum = {
    Party: "PARTY",
    Puid: "PUID",
} as const;

export type HotlineWarmlineCapAvailabilityEnum = (typeof HotlineWarmlineCapAvailabilityEnum)[keyof typeof HotlineWarmlineCapAvailabilityEnum];
export const HotlineWarmlineCapChangeableEnum = {
    CanModify: "CAN_MODIFY",
    ReadOnly: "READ_ONLY",
} as const;

export type HotlineWarmlineCapChangeableEnum = (typeof HotlineWarmlineCapChangeableEnum)[keyof typeof HotlineWarmlineCapChangeableEnum];
export const HotlineWarmlineCapPredefinableEnum = {
    Predefinable: "PREDEFINABLE",
    None: "NONE",
} as const;

export type HotlineWarmlineCapPredefinableEnum = (typeof HotlineWarmlineCapPredefinableEnum)[keyof typeof HotlineWarmlineCapPredefinableEnum];

/**
 *
 * @export
 * @interface InhibitIncomingForwarded
 */
export interface InhibitIncomingForwarded {
    /**
     *
     * @type {string}
     * @memberof InhibitIncomingForwarded
     */
    inherit?: InhibitIncomingForwardedInheritEnum;
    /**
     *
     * @type {boolean}
     * @memberof InhibitIncomingForwarded
     */
    inhibitDataCall?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof InhibitIncomingForwarded
     */
    inhibitVoiceCall?: boolean;
}

export const InhibitIncomingForwardedInheritEnum = {
    Primary: "PRIMARY",
    Self: "SELF",
} as const;

export type InhibitIncomingForwardedInheritEnum = (typeof InhibitIncomingForwardedInheritEnum)[keyof typeof InhibitIncomingForwardedInheritEnum];

/**
 *
 * @export
 * @interface InhibitIncomingForwardedCap
 */
export interface InhibitIncomingForwardedCap {
    /**
     *
     * @type {string}
     * @memberof InhibitIncomingForwardedCap
     */
    availability?: InhibitIncomingForwardedCapAvailabilityEnum;
    /**
     *
     * @type {string}
     * @memberof InhibitIncomingForwardedCap
     */
    changeable?: InhibitIncomingForwardedCapChangeableEnum;
    /**
     *
     * @type {string}
     * @memberof InhibitIncomingForwardedCap
     */
    predefinable?: InhibitIncomingForwardedCapPredefinableEnum;
}

export const InhibitIncomingForwardedCapAvailabilityEnum = {
    Party: "PARTY",
    Puid: "PUID",
} as const;

export type InhibitIncomingForwardedCapAvailabilityEnum =
    (typeof InhibitIncomingForwardedCapAvailabilityEnum)[keyof typeof InhibitIncomingForwardedCapAvailabilityEnum];
export const InhibitIncomingForwardedCapChangeableEnum = {
    CanModify: "CAN_MODIFY",
    ReadOnly: "READ_ONLY",
} as const;

export type InhibitIncomingForwardedCapChangeableEnum =
    (typeof InhibitIncomingForwardedCapChangeableEnum)[keyof typeof InhibitIncomingForwardedCapChangeableEnum];
export const InhibitIncomingForwardedCapPredefinableEnum = {
    Predefinable: "PREDEFINABLE",
    None: "NONE",
} as const;

export type InhibitIncomingForwardedCapPredefinableEnum =
    (typeof InhibitIncomingForwardedCapPredefinableEnum)[keyof typeof InhibitIncomingForwardedCapPredefinableEnum];

/**
 *
 * @export
 * @interface LanguageSelection
 */
export interface LanguageSelection {
    /**
     *
     * @type {string}
     * @memberof LanguageSelection
     */
    inherit?: LanguageSelectionInheritEnum;
    /**
     *
     * @type {string}
     * @memberof LanguageSelection
     */
    userSelectedLocale?: string;
}

export const LanguageSelectionInheritEnum = {
    Primary: "PRIMARY",
    Self: "SELF",
} as const;

export type LanguageSelectionInheritEnum = (typeof LanguageSelectionInheritEnum)[keyof typeof LanguageSelectionInheritEnum];

/**
 *
 * @export
 * @interface LanguageSelectionCap
 */
export interface LanguageSelectionCap {
    /**
     *
     * @type {string}
     * @memberof LanguageSelectionCap
     */
    availability?: LanguageSelectionCapAvailabilityEnum;
    /**
     *
     * @type {string}
     * @memberof LanguageSelectionCap
     */
    changeable?: LanguageSelectionCapChangeableEnum;
    /**
     *
     * @type {string}
     * @memberof LanguageSelectionCap
     */
    predefinable?: LanguageSelectionCapPredefinableEnum;
}

export const LanguageSelectionCapAvailabilityEnum = {
    Party: "PARTY",
    Puid: "PUID",
} as const;

export type LanguageSelectionCapAvailabilityEnum = (typeof LanguageSelectionCapAvailabilityEnum)[keyof typeof LanguageSelectionCapAvailabilityEnum];
export const LanguageSelectionCapChangeableEnum = {
    CanModify: "CAN_MODIFY",
    ReadOnly: "READ_ONLY",
} as const;

export type LanguageSelectionCapChangeableEnum = (typeof LanguageSelectionCapChangeableEnum)[keyof typeof LanguageSelectionCapChangeableEnum];
export const LanguageSelectionCapPredefinableEnum = {
    Predefinable: "PREDEFINABLE",
    None: "NONE",
} as const;

export type LanguageSelectionCapPredefinableEnum = (typeof LanguageSelectionCapPredefinableEnum)[keyof typeof LanguageSelectionCapPredefinableEnum];

/**
 *
 * @export
 * @interface Locales
 */
export interface Locales {
    /**
     *
     * @type {Array<string>}
     * @memberof Locales
     */
    locales?: Array<string>;
}
/**
 *
 * @export
 * @interface MiRingBack
 */
export interface MiRingBack {
    /**
     *
     * @type {string}
     * @memberof MiRingBack
     */
    inherit?: MiRingBackInheritEnum;
    /**
     *
     * @type {string}
     * @memberof MiRingBack
     */
    status?: MiRingBackStatusEnum;
}

export const MiRingBackInheritEnum = {
    Primary: "PRIMARY",
    Self: "SELF",
} as const;

export type MiRingBackInheritEnum = (typeof MiRingBackInheritEnum)[keyof typeof MiRingBackInheritEnum];
export const MiRingBackStatusEnum = {
    On: "ON",
    Off: "OFF",
} as const;

export type MiRingBackStatusEnum = (typeof MiRingBackStatusEnum)[keyof typeof MiRingBackStatusEnum];

/**
 *
 * @export
 * @interface MiRingbackCap
 */
export interface MiRingbackCap {
    /**
     *
     * @type {string}
     * @memberof MiRingbackCap
     */
    availability?: MiRingbackCapAvailabilityEnum;
    /**
     *
     * @type {string}
     * @memberof MiRingbackCap
     */
    changeable?: MiRingbackCapChangeableEnum;
    /**
     *
     * @type {string}
     * @memberof MiRingbackCap
     */
    predefinable?: MiRingbackCapPredefinableEnum;
}

export const MiRingbackCapAvailabilityEnum = {
    Party: "PARTY",
    Puid: "PUID",
} as const;

export type MiRingbackCapAvailabilityEnum = (typeof MiRingbackCapAvailabilityEnum)[keyof typeof MiRingbackCapAvailabilityEnum];
export const MiRingbackCapChangeableEnum = {
    CanModify: "CAN_MODIFY",
    ReadOnly: "READ_ONLY",
} as const;

export type MiRingbackCapChangeableEnum = (typeof MiRingbackCapChangeableEnum)[keyof typeof MiRingbackCapChangeableEnum];
export const MiRingbackCapPredefinableEnum = {
    Predefinable: "PREDEFINABLE",
    None: "NONE",
} as const;

export type MiRingbackCapPredefinableEnum = (typeof MiRingbackCapPredefinableEnum)[keyof typeof MiRingbackCapPredefinableEnum];

/**
 *
 * @export
 * @interface MultipleRingPattern
 */
export interface MultipleRingPattern {
    /**
     *
     * @type {string}
     * @memberof MultipleRingPattern
     */
    inherit?: MultipleRingPatternInheritEnum;
    /**
     *
     * @type {string}
     * @memberof MultipleRingPattern
     */
    ringPattern?: MultipleRingPatternRingPatternEnum;
}

export const MultipleRingPatternInheritEnum = {
    Primary: "PRIMARY",
    Self: "SELF",
} as const;

export type MultipleRingPatternInheritEnum = (typeof MultipleRingPatternInheritEnum)[keyof typeof MultipleRingPatternInheritEnum];
export const MultipleRingPatternRingPatternEnum = {
    Standard: "STANDARD",
    Pattern1: "PATTERN_1",
    Pattern2: "PATTERN_2",
    Pattern3: "PATTERN_3",
    Pattern4: "PATTERN_4",
    Pattern5: "PATTERN_5",
    Pattern6: "PATTERN_6",
} as const;

export type MultipleRingPatternRingPatternEnum = (typeof MultipleRingPatternRingPatternEnum)[keyof typeof MultipleRingPatternRingPatternEnum];

/**
 *
 * @export
 * @interface MultipleRingPatternCap
 */
export interface MultipleRingPatternCap {
    /**
     *
     * @type {string}
     * @memberof MultipleRingPatternCap
     */
    availability?: MultipleRingPatternCapAvailabilityEnum;
    /**
     *
     * @type {string}
     * @memberof MultipleRingPatternCap
     */
    changeable?: MultipleRingPatternCapChangeableEnum;
    /**
     *
     * @type {string}
     * @memberof MultipleRingPatternCap
     */
    predefinable?: MultipleRingPatternCapPredefinableEnum;
}

export const MultipleRingPatternCapAvailabilityEnum = {
    Party: "PARTY",
    Puid: "PUID",
} as const;

export type MultipleRingPatternCapAvailabilityEnum = (typeof MultipleRingPatternCapAvailabilityEnum)[keyof typeof MultipleRingPatternCapAvailabilityEnum];
export const MultipleRingPatternCapChangeableEnum = {
    CanModify: "CAN_MODIFY",
    ReadOnly: "READ_ONLY",
} as const;

export type MultipleRingPatternCapChangeableEnum = (typeof MultipleRingPatternCapChangeableEnum)[keyof typeof MultipleRingPatternCapChangeableEnum];
export const MultipleRingPatternCapPredefinableEnum = {
    Predefinable: "PREDEFINABLE",
    None: "NONE",
} as const;

export type MultipleRingPatternCapPredefinableEnum = (typeof MultipleRingPatternCapPredefinableEnum)[keyof typeof MultipleRingPatternCapPredefinableEnum];

/**
 *
 * @export
 * @interface MusicOnHold
 */
export interface MusicOnHold {
    /**
     *
     * @type {string}
     * @memberof MusicOnHold
     */
    inherit?: MusicOnHoldInheritEnum;
    /**
     *
     * @type {string}
     * @memberof MusicOnHold
     */
    status?: MusicOnHoldStatusEnum;
}

export const MusicOnHoldInheritEnum = {
    Primary: "PRIMARY",
    Self: "SELF",
} as const;

export type MusicOnHoldInheritEnum = (typeof MusicOnHoldInheritEnum)[keyof typeof MusicOnHoldInheritEnum];
export const MusicOnHoldStatusEnum = {
    On: "ON",
    Off: "OFF",
} as const;

export type MusicOnHoldStatusEnum = (typeof MusicOnHoldStatusEnum)[keyof typeof MusicOnHoldStatusEnum];

/**
 *
 * @export
 * @interface MusicOnHoldCap
 */
export interface MusicOnHoldCap {
    /**
     *
     * @type {string}
     * @memberof MusicOnHoldCap
     */
    availability?: MusicOnHoldCapAvailabilityEnum;
    /**
     *
     * @type {string}
     * @memberof MusicOnHoldCap
     */
    changeable?: MusicOnHoldCapChangeableEnum;
    /**
     *
     * @type {string}
     * @memberof MusicOnHoldCap
     */
    predefinable?: MusicOnHoldCapPredefinableEnum;
}

export const MusicOnHoldCapAvailabilityEnum = {
    Party: "PARTY",
    Puid: "PUID",
} as const;

export type MusicOnHoldCapAvailabilityEnum = (typeof MusicOnHoldCapAvailabilityEnum)[keyof typeof MusicOnHoldCapAvailabilityEnum];
export const MusicOnHoldCapChangeableEnum = {
    CanModify: "CAN_MODIFY",
    ReadOnly: "READ_ONLY",
} as const;

export type MusicOnHoldCapChangeableEnum = (typeof MusicOnHoldCapChangeableEnum)[keyof typeof MusicOnHoldCapChangeableEnum];
export const MusicOnHoldCapPredefinableEnum = {
    Predefinable: "PREDEFINABLE",
    None: "NONE",
} as const;

export type MusicOnHoldCapPredefinableEnum = (typeof MusicOnHoldCapPredefinableEnum)[keyof typeof MusicOnHoldCapPredefinableEnum];

/**
 *
 * @export
 * @interface OcbProgram
 */
export interface OcbProgram {
    /**
     *
     * @type {boolean}
     * @memberof OcbProgram
     */
    "allow-user-control"?: boolean;
    /**
     *
     * @type {string}
     * @memberof OcbProgram
     */
    description?: string;
    /**
     *
     * @type {number}
     * @memberof OcbProgram
     */
    "ocb-program-id"?: number;
}
/**
 *
 * @export
 * @interface OcbPrograms
 */
export interface OcbPrograms {
    /**
     *
     * @type {Array<OcbProgram>}
     * @memberof OcbPrograms
     */
    ocbPrograms?: Array<OcbProgram>;
}
/**
 *
 * @export
 * @interface OneNumberCap
 */
export interface OneNumberCap {
    /**
     *
     * @type {string}
     * @memberof OneNumberCap
     */
    availability?: OneNumberCapAvailabilityEnum;
    /**
     *
     * @type {string}
     * @memberof OneNumberCap
     */
    changeable?: OneNumberCapChangeableEnum;
    /**
     *
     * @type {string}
     * @memberof OneNumberCap
     */
    predefinable?: OneNumberCapPredefinableEnum;
    /**
     *
     * @type {string}
     * @memberof OneNumberCap
     */
    ringingMethod?: OneNumberCapRingingMethodEnum;
}

export const OneNumberCapAvailabilityEnum = {
    Party: "PARTY",
    Puid: "PUID",
} as const;

export type OneNumberCapAvailabilityEnum = (typeof OneNumberCapAvailabilityEnum)[keyof typeof OneNumberCapAvailabilityEnum];
export const OneNumberCapChangeableEnum = {
    CanModify: "CAN_MODIFY",
    ReadOnly: "READ_ONLY",
} as const;

export type OneNumberCapChangeableEnum = (typeof OneNumberCapChangeableEnum)[keyof typeof OneNumberCapChangeableEnum];
export const OneNumberCapPredefinableEnum = {
    Predefinable: "PREDEFINABLE",
    None: "NONE",
} as const;

export type OneNumberCapPredefinableEnum = (typeof OneNumberCapPredefinableEnum)[keyof typeof OneNumberCapPredefinableEnum];
export const OneNumberCapRingingMethodEnum = {
    Inactive: "INACTIVE",
    Simrng: "SIMRNG",
    Seqrng: "SEQRNG",
} as const;

export type OneNumberCapRingingMethodEnum = (typeof OneNumberCapRingingMethodEnum)[keyof typeof OneNumberCapRingingMethodEnum];

/**
 *
 * @export
 * @interface OutgoingCallBarring
 */
export interface OutgoingCallBarring {
    /**
     *
     * @type {string}
     * @memberof OutgoingCallBarring
     */
    inherit?: OutgoingCallBarringInheritEnum;
    /**
     *
     * @type {boolean}
     * @memberof OutgoingCallBarring
     */
    specialDialTone?: boolean;
    /**
     *
     * @type {string}
     * @memberof OutgoingCallBarring
     */
    status?: OutgoingCallBarringStatusEnum;
    /**
     *
     * @type {number}
     * @memberof OutgoingCallBarring
     */
    userProgramId?: number;
}

export const OutgoingCallBarringInheritEnum = {
    Primary: "PRIMARY",
    Self: "SELF",
} as const;

export type OutgoingCallBarringInheritEnum = (typeof OutgoingCallBarringInheritEnum)[keyof typeof OutgoingCallBarringInheritEnum];
export const OutgoingCallBarringStatusEnum = {
    On: "ON",
    Off: "OFF",
} as const;

export type OutgoingCallBarringStatusEnum = (typeof OutgoingCallBarringStatusEnum)[keyof typeof OutgoingCallBarringStatusEnum];

/**
 *
 * @export
 * @interface OutgoingCallBarringCap
 */
export interface OutgoingCallBarringCap {
    /**
     *
     * @type {string}
     * @memberof OutgoingCallBarringCap
     */
    availability?: OutgoingCallBarringCapAvailabilityEnum;
    /**
     *
     * @type {string}
     * @memberof OutgoingCallBarringCap
     */
    changeable?: OutgoingCallBarringCapChangeableEnum;
    /**
     *
     * @type {string}
     * @memberof OutgoingCallBarringCap
     */
    predefinable?: OutgoingCallBarringCapPredefinableEnum;
}

export const OutgoingCallBarringCapAvailabilityEnum = {
    Party: "PARTY",
    Puid: "PUID",
} as const;

export type OutgoingCallBarringCapAvailabilityEnum = (typeof OutgoingCallBarringCapAvailabilityEnum)[keyof typeof OutgoingCallBarringCapAvailabilityEnum];
export const OutgoingCallBarringCapChangeableEnum = {
    CanModify: "CAN_MODIFY",
    ReadOnly: "READ_ONLY",
} as const;

export type OutgoingCallBarringCapChangeableEnum = (typeof OutgoingCallBarringCapChangeableEnum)[keyof typeof OutgoingCallBarringCapChangeableEnum];
export const OutgoingCallBarringCapPredefinableEnum = {
    Predefinable: "PREDEFINABLE",
    None: "NONE",
} as const;

export type OutgoingCallBarringCapPredefinableEnum = (typeof OutgoingCallBarringCapPredefinableEnum)[keyof typeof OutgoingCallBarringCapPredefinableEnum];

/**
 *
 * @export
 * @interface PersonalizedRingbackTone
 */
export interface PersonalizedRingbackTone {
    /**
     *
     * @type {string}
     * @memberof PersonalizedRingbackTone
     */
    inherit?: PersonalizedRingbackToneInheritEnum;
    /**
     *
     * @type {string}
     * @memberof PersonalizedRingbackTone
     */
    status?: PersonalizedRingbackToneStatusEnum;
}

export const PersonalizedRingbackToneInheritEnum = {
    Primary: "PRIMARY",
    Self: "SELF",
} as const;

export type PersonalizedRingbackToneInheritEnum = (typeof PersonalizedRingbackToneInheritEnum)[keyof typeof PersonalizedRingbackToneInheritEnum];
export const PersonalizedRingbackToneStatusEnum = {
    On: "ON",
    Off: "OFF",
} as const;

export type PersonalizedRingbackToneStatusEnum = (typeof PersonalizedRingbackToneStatusEnum)[keyof typeof PersonalizedRingbackToneStatusEnum];

/**
 *
 * @export
 * @interface PersonalizedRingbackToneCap
 */
export interface PersonalizedRingbackToneCap {
    /**
     *
     * @type {string}
     * @memberof PersonalizedRingbackToneCap
     */
    availability?: PersonalizedRingbackToneCapAvailabilityEnum;
    /**
     *
     * @type {string}
     * @memberof PersonalizedRingbackToneCap
     */
    changeable?: PersonalizedRingbackToneCapChangeableEnum;
    /**
     *
     * @type {string}
     * @memberof PersonalizedRingbackToneCap
     */
    predefinable?: PersonalizedRingbackToneCapPredefinableEnum;
}

export const PersonalizedRingbackToneCapAvailabilityEnum = {
    Party: "PARTY",
    Puid: "PUID",
} as const;

export type PersonalizedRingbackToneCapAvailabilityEnum =
    (typeof PersonalizedRingbackToneCapAvailabilityEnum)[keyof typeof PersonalizedRingbackToneCapAvailabilityEnum];
export const PersonalizedRingbackToneCapChangeableEnum = {
    CanModify: "CAN_MODIFY",
    ReadOnly: "READ_ONLY",
} as const;

export type PersonalizedRingbackToneCapChangeableEnum =
    (typeof PersonalizedRingbackToneCapChangeableEnum)[keyof typeof PersonalizedRingbackToneCapChangeableEnum];
export const PersonalizedRingbackToneCapPredefinableEnum = {
    Predefinable: "PREDEFINABLE",
    None: "NONE",
} as const;

export type PersonalizedRingbackToneCapPredefinableEnum =
    (typeof PersonalizedRingbackToneCapPredefinableEnum)[keyof typeof PersonalizedRingbackToneCapPredefinableEnum];

/**
 *
 * @export
 * @interface PinService
 */
export interface PinService {
    /**
     *
     * @type {string}
     * @memberof PinService
     */
    inherit?: PinServiceInheritEnum;
    /**
     *
     * @type {string}
     * @memberof PinService
     */
    pinNum?: string;
}

export const PinServiceInheritEnum = {
    Primary: "PRIMARY",
    Self: "SELF",
} as const;

export type PinServiceInheritEnum = (typeof PinServiceInheritEnum)[keyof typeof PinServiceInheritEnum];

/**
 *
 * @export
 * @interface PinServiceCap
 */
export interface PinServiceCap {
    /**
     *
     * @type {string}
     * @memberof PinServiceCap
     */
    availability?: PinServiceCapAvailabilityEnum;
    /**
     *
     * @type {string}
     * @memberof PinServiceCap
     */
    changeable?: PinServiceCapChangeableEnum;
    /**
     *
     * @type {boolean}
     * @memberof PinServiceCap
     */
    pinNeedReset?: boolean;
    /**
     *
     * @type {string}
     * @memberof PinServiceCap
     */
    predefinable?: PinServiceCapPredefinableEnum;
}

export const PinServiceCapAvailabilityEnum = {
    Party: "PARTY",
    Puid: "PUID",
} as const;

export type PinServiceCapAvailabilityEnum = (typeof PinServiceCapAvailabilityEnum)[keyof typeof PinServiceCapAvailabilityEnum];
export const PinServiceCapChangeableEnum = {
    CanModify: "CAN_MODIFY",
    ReadOnly: "READ_ONLY",
} as const;

export type PinServiceCapChangeableEnum = (typeof PinServiceCapChangeableEnum)[keyof typeof PinServiceCapChangeableEnum];
export const PinServiceCapPredefinableEnum = {
    Predefinable: "PREDEFINABLE",
    None: "NONE",
} as const;

export type PinServiceCapPredefinableEnum = (typeof PinServiceCapPredefinableEnum)[keyof typeof PinServiceCapPredefinableEnum];

/**
 *
 * @export
 * @interface PuidList
 */
export interface PuidList {
    /**
     *
     * @type {string}
     * @memberof PuidList
     */
    primaryPuid?: string;
    /**
     *
     * @type {Array<string>}
     * @memberof PuidList
     */
    secondaryPuids?: Array<string>;
}
/**
 * The Nokia TAS API may add a service exception into the response body to provide more information in case of an unsuccessful API call. This is done by including a RequestError element into the response body.  **serviceException**: Faults related to the operation of the service, result in the return of a ServiceException message.
 * @export
 * @interface RequestError
 */
export interface RequestError {
    /**
     *
     * @type {ServiceException}
     * @memberof RequestError
     */
    serviceException: ServiceException;
}
/**
 *
 * @export
 * @interface SEQRNGEntry
 */
export interface SEQRNGEntry {
    /**
     *
     * @type {boolean}
     * @memberof SEQRNGEntry
     */
    ansConfirm?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof SEQRNGEntry
     */
    continueOnBusy?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof SEQRNGEntry
     */
    continueOnNoAnswer?: boolean;
    /**
     *
     * @type {number}
     * @memberof SEQRNGEntry
     */
    naTimeout?: number;
    /**
     *
     * @type {string}
     * @memberof SEQRNGEntry
     */
    ringPattern?: SEQRNGEntryRingPatternEnum;
    /**
     *
     * @type {string}
     * @memberof SEQRNGEntry
     */
    seqDN?: string;
}

export const SEQRNGEntryRingPatternEnum = {
    Standard: "STANDARD",
    Pattern1: "PATTERN_1",
    Pattern2: "PATTERN_2",
    Pattern3: "PATTERN_3",
    Pattern4: "PATTERN_4",
    Pattern5: "PATTERN_5",
    Pattern6: "PATTERN_6",
} as const;

export type SEQRNGEntryRingPatternEnum = (typeof SEQRNGEntryRingPatternEnum)[keyof typeof SEQRNGEntryRingPatternEnum];

/**
 *
 * @export
 * @interface SIMRNGEntry
 */
export interface SIMRNGEntry {
    /**
     *
     * @type {boolean}
     * @memberof SIMRNGEntry
     */
    ansConfirm?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof SIMRNGEntry
     */
    family?: boolean;
    /**
     *
     * @type {string}
     * @memberof SIMRNGEntry
     */
    ringPattern?: SIMRNGEntryRingPatternEnum;
    /**
     *
     * @type {string}
     * @memberof SIMRNGEntry
     */
    simDN?: string;
}

export const SIMRNGEntryRingPatternEnum = {
    Standard: "STANDARD",
    Pattern1: "PATTERN_1",
    Pattern2: "PATTERN_2",
    Pattern3: "PATTERN_3",
    Pattern4: "PATTERN_4",
    Pattern5: "PATTERN_5",
    Pattern6: "PATTERN_6",
} as const;

export type SIMRNGEntryRingPatternEnum = (typeof SIMRNGEntryRingPatternEnum)[keyof typeof SIMRNGEntryRingPatternEnum];

/**
 *
 * @export
 * @interface SdaEntry
 */
export interface SdaEntry {
    /**
     *
     * @type {string}
     * @memberof SdaEntry
     */
    ringPattern?: SdaEntryRingPatternEnum;
    /**
     *
     * @type {string}
     * @memberof SdaEntry
     */
    sdaDN?: string;
}

export const SdaEntryRingPatternEnum = {
    Standard: "STANDARD",
    Pattern1: "PATTERN_1",
    Pattern2: "PATTERN_2",
    Pattern3: "PATTERN_3",
    Pattern4: "PATTERN_4",
    Pattern5: "PATTERN_5",
    Pattern6: "PATTERN_6",
} as const;

export type SdaEntryRingPatternEnum = (typeof SdaEntryRingPatternEnum)[keyof typeof SdaEntryRingPatternEnum];

/**
 *
 * @export
 * @interface SelRejectEntry
 */
export interface SelRejectEntry {
    /**
     *
     * @type {string}
     * @memberof SelRejectEntry
     */
    selectiveDN?: string;
    /**
     *
     * @type {number}
     * @memberof SelRejectEntry
     */
    timestamp?: number;
    /**
     *
     * @type {string}
     * @memberof SelRejectEntry
     */
    token?: string;
}
/**
 *
 * @export
 * @interface SelectiveCallAcceptance
 */
export interface SelectiveCallAcceptance {
    /**
     *
     * @type {string}
     * @memberof SelectiveCallAcceptance
     */
    fwdDN?: string;
    /**
     *
     * @type {string}
     * @memberof SelectiveCallAcceptance
     */
    fwdToType?: SelectiveCallAcceptanceFwdToTypeEnum;
    /**
     *
     * @type {string}
     * @memberof SelectiveCallAcceptance
     */
    inherit?: SelectiveCallAcceptanceInheritEnum;
    /**
     *
     * @type {boolean}
     * @memberof SelectiveCallAcceptance
     */
    restrictIdBackward?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof SelectiveCallAcceptance
     */
    restrictIdForward?: boolean;
    /**
     *
     * @type {Array<SelectiveDNEntry>}
     * @memberof SelectiveCallAcceptance
     */
    scaList?: Array<SelectiveDNEntry>;
    /**
     *
     * @type {string}
     * @memberof SelectiveCallAcceptance
     */
    status?: SelectiveCallAcceptanceStatusEnum;
    /**
     *
     * @type {string}
     * @memberof SelectiveCallAcceptance
     */
    tas181Mode?: SelectiveCallAcceptanceTas181ModeEnum;
    /**
     *
     * @type {boolean}
     * @memberof SelectiveCallAcceptance
     */
    useForwarded?: boolean;
}

export const SelectiveCallAcceptanceFwdToTypeEnum = {
    Dn: "TO_DN",
    Vms: "TO_VMS",
    Attnd: "TO_ATTND",
} as const;

export type SelectiveCallAcceptanceFwdToTypeEnum = (typeof SelectiveCallAcceptanceFwdToTypeEnum)[keyof typeof SelectiveCallAcceptanceFwdToTypeEnum];
export const SelectiveCallAcceptanceInheritEnum = {
    Primary: "PRIMARY",
    Self: "SELF",
} as const;

export type SelectiveCallAcceptanceInheritEnum = (typeof SelectiveCallAcceptanceInheritEnum)[keyof typeof SelectiveCallAcceptanceInheritEnum];
export const SelectiveCallAcceptanceStatusEnum = {
    On: "ON",
    Off: "OFF",
} as const;

export type SelectiveCallAcceptanceStatusEnum = (typeof SelectiveCallAcceptanceStatusEnum)[keyof typeof SelectiveCallAcceptanceStatusEnum];
export const SelectiveCallAcceptanceTas181ModeEnum = {
    None: "TAS_181_NONE",
    NoFwinfo: "TAS_181_NO_FWINFO",
    WithFwinfo: "TAS_181_WITH_FWINFO",
} as const;

export type SelectiveCallAcceptanceTas181ModeEnum = (typeof SelectiveCallAcceptanceTas181ModeEnum)[keyof typeof SelectiveCallAcceptanceTas181ModeEnum];

/**
 *
 * @export
 * @interface SelectiveCallAcceptanceCap
 */
export interface SelectiveCallAcceptanceCap {
    /**
     *
     * @type {string}
     * @memberof SelectiveCallAcceptanceCap
     */
    availability?: SelectiveCallAcceptanceCapAvailabilityEnum;
    /**
     *
     * @type {string}
     * @memberof SelectiveCallAcceptanceCap
     */
    changeable?: SelectiveCallAcceptanceCapChangeableEnum;
    /**
     *
     * @type {string}
     * @memberof SelectiveCallAcceptanceCap
     */
    predefinable?: SelectiveCallAcceptanceCapPredefinableEnum;
}

export const SelectiveCallAcceptanceCapAvailabilityEnum = {
    Party: "PARTY",
    Puid: "PUID",
} as const;

export type SelectiveCallAcceptanceCapAvailabilityEnum =
    (typeof SelectiveCallAcceptanceCapAvailabilityEnum)[keyof typeof SelectiveCallAcceptanceCapAvailabilityEnum];
export const SelectiveCallAcceptanceCapChangeableEnum = {
    CanModify: "CAN_MODIFY",
    ReadOnly: "READ_ONLY",
} as const;

export type SelectiveCallAcceptanceCapChangeableEnum = (typeof SelectiveCallAcceptanceCapChangeableEnum)[keyof typeof SelectiveCallAcceptanceCapChangeableEnum];
export const SelectiveCallAcceptanceCapPredefinableEnum = {
    Predefinable: "PREDEFINABLE",
    None: "NONE",
} as const;

export type SelectiveCallAcceptanceCapPredefinableEnum =
    (typeof SelectiveCallAcceptanceCapPredefinableEnum)[keyof typeof SelectiveCallAcceptanceCapPredefinableEnum];

/**
 *
 * @export
 * @interface SelectiveCallForwarding
 */
export interface SelectiveCallForwarding {
    /**
     *
     * @type {string}
     * @memberof SelectiveCallForwarding
     */
    fwdDN?: string;
    /**
     *
     * @type {string}
     * @memberof SelectiveCallForwarding
     */
    fwdToType?: SelectiveCallForwardingFwdToTypeEnum;
    /**
     *
     * @type {string}
     * @memberof SelectiveCallForwarding
     */
    inherit?: SelectiveCallForwardingInheritEnum;
    /**
     *
     * @type {number}
     * @memberof SelectiveCallForwarding
     */
    naTimeout?: number;
    /**
     *
     * @type {boolean}
     * @memberof SelectiveCallForwarding
     */
    pingRing?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof SelectiveCallForwarding
     */
    restrictIdBackward?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof SelectiveCallForwarding
     */
    restrictIdForward?: boolean;
    /**
     *
     * @type {Array<SelectiveDNEntry>}
     * @memberof SelectiveCallForwarding
     */
    scfList?: Array<SelectiveDNEntry>;
    /**
     *
     * @type {string}
     * @memberof SelectiveCallForwarding
     */
    scfType?: SelectiveCallForwardingScfTypeEnum;
    /**
     *
     * @type {string}
     * @memberof SelectiveCallForwarding
     */
    status?: SelectiveCallForwardingStatusEnum;
    /**
     *
     * @type {string}
     * @memberof SelectiveCallForwarding
     */
    tas181Mode?: SelectiveCallForwardingTas181ModeEnum;
}

export const SelectiveCallForwardingFwdToTypeEnum = {
    Dn: "TO_DN",
    Vms: "TO_VMS",
    Attnd: "TO_ATTND",
} as const;

export type SelectiveCallForwardingFwdToTypeEnum = (typeof SelectiveCallForwardingFwdToTypeEnum)[keyof typeof SelectiveCallForwardingFwdToTypeEnum];
export const SelectiveCallForwardingInheritEnum = {
    Primary: "PRIMARY",
    Self: "SELF",
} as const;

export type SelectiveCallForwardingInheritEnum = (typeof SelectiveCallForwardingInheritEnum)[keyof typeof SelectiveCallForwardingInheritEnum];
export const SelectiveCallForwardingScfTypeEnum = {
    Unconditional: "UNCONDITIONAL",
    Busy: "BUSY",
    Noresponse: "NORESPONSE",
    Unreachable: "UNREACHABLE",
} as const;

export type SelectiveCallForwardingScfTypeEnum = (typeof SelectiveCallForwardingScfTypeEnum)[keyof typeof SelectiveCallForwardingScfTypeEnum];
export const SelectiveCallForwardingStatusEnum = {
    On: "ON",
    Off: "OFF",
} as const;

export type SelectiveCallForwardingStatusEnum = (typeof SelectiveCallForwardingStatusEnum)[keyof typeof SelectiveCallForwardingStatusEnum];
export const SelectiveCallForwardingTas181ModeEnum = {
    None: "TAS_181_NONE",
    NoFwinfo: "TAS_181_NO_FWINFO",
    WithFwinfo: "TAS_181_WITH_FWINFO",
} as const;

export type SelectiveCallForwardingTas181ModeEnum = (typeof SelectiveCallForwardingTas181ModeEnum)[keyof typeof SelectiveCallForwardingTas181ModeEnum];

/**
 *
 * @export
 * @interface SelectiveCallForwardingCap
 */
export interface SelectiveCallForwardingCap {
    /**
     *
     * @type {string}
     * @memberof SelectiveCallForwardingCap
     */
    availability?: SelectiveCallForwardingCapAvailabilityEnum;
    /**
     *
     * @type {string}
     * @memberof SelectiveCallForwardingCap
     */
    changeable?: SelectiveCallForwardingCapChangeableEnum;
    /**
     *
     * @type {number}
     * @memberof SelectiveCallForwardingCap
     */
    maxRange?: number;
    /**
     *
     * @type {number}
     * @memberof SelectiveCallForwardingCap
     */
    minRange?: number;
    /**
     *
     * @type {string}
     * @memberof SelectiveCallForwardingCap
     */
    predefinable?: SelectiveCallForwardingCapPredefinableEnum;
}

export const SelectiveCallForwardingCapAvailabilityEnum = {
    Party: "PARTY",
    Puid: "PUID",
} as const;

export type SelectiveCallForwardingCapAvailabilityEnum =
    (typeof SelectiveCallForwardingCapAvailabilityEnum)[keyof typeof SelectiveCallForwardingCapAvailabilityEnum];
export const SelectiveCallForwardingCapChangeableEnum = {
    CanModify: "CAN_MODIFY",
    ReadOnly: "READ_ONLY",
} as const;

export type SelectiveCallForwardingCapChangeableEnum = (typeof SelectiveCallForwardingCapChangeableEnum)[keyof typeof SelectiveCallForwardingCapChangeableEnum];
export const SelectiveCallForwardingCapPredefinableEnum = {
    Predefinable: "PREDEFINABLE",
    None: "NONE",
} as const;

export type SelectiveCallForwardingCapPredefinableEnum =
    (typeof SelectiveCallForwardingCapPredefinableEnum)[keyof typeof SelectiveCallForwardingCapPredefinableEnum];

/**
 *
 * @export
 * @interface SelectiveCallRejection
 */
export interface SelectiveCallRejection {
    /**
     *
     * @type {string}
     * @memberof SelectiveCallRejection
     */
    inherit?: SelectiveCallRejectionInheritEnum;
    /**
     *
     * @type {boolean}
     * @memberof SelectiveCallRejection
     */
    pingRing?: boolean;
    /**
     *
     * @type {Array<SelRejectEntry>}
     * @memberof SelectiveCallRejection
     */
    selRejectList?: Array<SelRejectEntry>;
    /**
     *
     * @type {string}
     * @memberof SelectiveCallRejection
     */
    status?: SelectiveCallRejectionStatusEnum;
}

export const SelectiveCallRejectionInheritEnum = {
    Primary: "PRIMARY",
    Self: "SELF",
} as const;

export type SelectiveCallRejectionInheritEnum = (typeof SelectiveCallRejectionInheritEnum)[keyof typeof SelectiveCallRejectionInheritEnum];
export const SelectiveCallRejectionStatusEnum = {
    On: "ON",
    Off: "OFF",
} as const;

export type SelectiveCallRejectionStatusEnum = (typeof SelectiveCallRejectionStatusEnum)[keyof typeof SelectiveCallRejectionStatusEnum];

/**
 *
 * @export
 * @interface SelectiveCallRejectionCap
 */
export interface SelectiveCallRejectionCap {
    /**
     *
     * @type {string}
     * @memberof SelectiveCallRejectionCap
     */
    availability?: SelectiveCallRejectionCapAvailabilityEnum;
    /**
     *
     * @type {string}
     * @memberof SelectiveCallRejectionCap
     */
    changeable?: SelectiveCallRejectionCapChangeableEnum;
    /**
     *
     * @type {string}
     * @memberof SelectiveCallRejectionCap
     */
    predefinable?: SelectiveCallRejectionCapPredefinableEnum;
}

export const SelectiveCallRejectionCapAvailabilityEnum = {
    Party: "PARTY",
    Puid: "PUID",
} as const;

export type SelectiveCallRejectionCapAvailabilityEnum =
    (typeof SelectiveCallRejectionCapAvailabilityEnum)[keyof typeof SelectiveCallRejectionCapAvailabilityEnum];
export const SelectiveCallRejectionCapChangeableEnum = {
    CanModify: "CAN_MODIFY",
    ReadOnly: "READ_ONLY",
} as const;

export type SelectiveCallRejectionCapChangeableEnum = (typeof SelectiveCallRejectionCapChangeableEnum)[keyof typeof SelectiveCallRejectionCapChangeableEnum];
export const SelectiveCallRejectionCapPredefinableEnum = {
    Predefinable: "PREDEFINABLE",
    None: "NONE",
} as const;

export type SelectiveCallRejectionCapPredefinableEnum =
    (typeof SelectiveCallRejectionCapPredefinableEnum)[keyof typeof SelectiveCallRejectionCapPredefinableEnum];

/**
 *
 * @export
 * @interface SelectiveDNEntry
 */
export interface SelectiveDNEntry {
    /**
     *
     * @type {string}
     * @memberof SelectiveDNEntry
     */
    selectiveDN?: string;
}
/**
 *
 * @export
 * @interface SelectiveDistinctiveAlerting
 */
export interface SelectiveDistinctiveAlerting {
    /**
     *
     * @type {string}
     * @memberof SelectiveDistinctiveAlerting
     */
    inherit?: SelectiveDistinctiveAlertingInheritEnum;
    /**
     *
     * @type {Array<SdaEntry>}
     * @memberof SelectiveDistinctiveAlerting
     */
    sdaLists?: Array<SdaEntry>;
    /**
     *
     * @type {string}
     * @memberof SelectiveDistinctiveAlerting
     */
    status?: SelectiveDistinctiveAlertingStatusEnum;
}

export const SelectiveDistinctiveAlertingInheritEnum = {
    Primary: "PRIMARY",
    Self: "SELF",
} as const;

export type SelectiveDistinctiveAlertingInheritEnum = (typeof SelectiveDistinctiveAlertingInheritEnum)[keyof typeof SelectiveDistinctiveAlertingInheritEnum];
export const SelectiveDistinctiveAlertingStatusEnum = {
    On: "ON",
    Off: "OFF",
} as const;

export type SelectiveDistinctiveAlertingStatusEnum = (typeof SelectiveDistinctiveAlertingStatusEnum)[keyof typeof SelectiveDistinctiveAlertingStatusEnum];

/**
 *
 * @export
 * @interface SelectiveDistinctiveAlertingCap
 */
export interface SelectiveDistinctiveAlertingCap {
    /**
     *
     * @type {string}
     * @memberof SelectiveDistinctiveAlertingCap
     */
    availability?: SelectiveDistinctiveAlertingCapAvailabilityEnum;
    /**
     *
     * @type {string}
     * @memberof SelectiveDistinctiveAlertingCap
     */
    changeable?: SelectiveDistinctiveAlertingCapChangeableEnum;
    /**
     *
     * @type {string}
     * @memberof SelectiveDistinctiveAlertingCap
     */
    predefinable?: SelectiveDistinctiveAlertingCapPredefinableEnum;
}

export const SelectiveDistinctiveAlertingCapAvailabilityEnum = {
    Party: "PARTY",
    Puid: "PUID",
} as const;

export type SelectiveDistinctiveAlertingCapAvailabilityEnum =
    (typeof SelectiveDistinctiveAlertingCapAvailabilityEnum)[keyof typeof SelectiveDistinctiveAlertingCapAvailabilityEnum];
export const SelectiveDistinctiveAlertingCapChangeableEnum = {
    CanModify: "CAN_MODIFY",
    ReadOnly: "READ_ONLY",
} as const;

export type SelectiveDistinctiveAlertingCapChangeableEnum =
    (typeof SelectiveDistinctiveAlertingCapChangeableEnum)[keyof typeof SelectiveDistinctiveAlertingCapChangeableEnum];
export const SelectiveDistinctiveAlertingCapPredefinableEnum = {
    Predefinable: "PREDEFINABLE",
    None: "NONE",
} as const;

export type SelectiveDistinctiveAlertingCapPredefinableEnum =
    (typeof SelectiveDistinctiveAlertingCapPredefinableEnum)[keyof typeof SelectiveDistinctiveAlertingCapPredefinableEnum];

/**
 *
 * @export
 * @interface SequentialRing
 */
export interface SequentialRing {
    /**
     *
     * @type {boolean}
     * @memberof SequentialRing
     */
    continueOnBusy?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof SequentialRing
     */
    continueOnNoAnswer?: boolean;
    /**
     *
     * @type {number}
     * @memberof SequentialRing
     */
    defaultTimeout?: number;
    /**
     *
     * @type {string}
     * @memberof SequentialRing
     */
    inherit?: SequentialRingInheritEnum;
    /**
     *
     * @type {number}
     * @memberof SequentialRing
     */
    naTimeout?: number;
    /**
     *
     * @type {boolean}
     * @memberof SequentialRing
     */
    restrictIdBackward?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof SequentialRing
     */
    restrictIdForward?: boolean;
    /**
     *
     * @type {Array<SEQRNGEntry>}
     * @memberof SequentialRing
     */
    seqrngList?: Array<SEQRNGEntry>;
    /**
     *
     * @type {string}
     * @memberof SequentialRing
     */
    status?: SequentialRingStatusEnum;
    /**
     *
     * @type {string}
     * @memberof SequentialRing
     */
    tas181Mode?: SequentialRingTas181ModeEnum;
}

export const SequentialRingInheritEnum = {
    Primary: "PRIMARY",
    Self: "SELF",
} as const;

export type SequentialRingInheritEnum = (typeof SequentialRingInheritEnum)[keyof typeof SequentialRingInheritEnum];
export const SequentialRingStatusEnum = {
    On: "ON",
    Off: "OFF",
} as const;

export type SequentialRingStatusEnum = (typeof SequentialRingStatusEnum)[keyof typeof SequentialRingStatusEnum];
export const SequentialRingTas181ModeEnum = {
    None: "TAS_181_NONE",
    NoFwinfo: "TAS_181_NO_FWINFO",
    WithFwinfo: "TAS_181_WITH_FWINFO",
} as const;

export type SequentialRingTas181ModeEnum = (typeof SequentialRingTas181ModeEnum)[keyof typeof SequentialRingTas181ModeEnum];

/**
 *
 * @export
 * @interface SequentialRingCap
 */
export interface SequentialRingCap {
    /**
     *
     * @type {string}
     * @memberof SequentialRingCap
     */
    availability?: SequentialRingCapAvailabilityEnum;
    /**
     *
     * @type {string}
     * @memberof SequentialRingCap
     */
    changeable?: SequentialRingCapChangeableEnum;
    /**
     *
     * @type {string}
     * @memberof SequentialRingCap
     */
    predefinable?: SequentialRingCapPredefinableEnum;
}

export const SequentialRingCapAvailabilityEnum = {
    Party: "PARTY",
    Puid: "PUID",
} as const;

export type SequentialRingCapAvailabilityEnum = (typeof SequentialRingCapAvailabilityEnum)[keyof typeof SequentialRingCapAvailabilityEnum];
export const SequentialRingCapChangeableEnum = {
    CanModify: "CAN_MODIFY",
    ReadOnly: "READ_ONLY",
} as const;

export type SequentialRingCapChangeableEnum = (typeof SequentialRingCapChangeableEnum)[keyof typeof SequentialRingCapChangeableEnum];
export const SequentialRingCapPredefinableEnum = {
    Predefinable: "PREDEFINABLE",
    None: "NONE",
} as const;

export type SequentialRingCapPredefinableEnum = (typeof SequentialRingCapPredefinableEnum)[keyof typeof SequentialRingCapPredefinableEnum];

/**
 *
 * @export
 * @interface ServiceException
 */
export interface ServiceException {
    /**
     * Message identifier with a prefix SVC. The commonly used SVC are the following: SVC0002:Invalid input value; SVC0003:Invalid input value with list of valid values; SVC0004:No valid address(es); SVC0005:Duplicate correlator; SVC2000:Service error with description.
     * @type {string}
     * @memberof ServiceException
     */
    messageId: string;
    /**
     * Message text with replacement variables marked with %n, where n is an index in the list of <variables> elements, starting at 1.
     * @type {string}
     * @memberof ServiceException
     */
    text: string;
    /**
     *
     * @type {Array<string>}
     * @memberof ServiceException
     */
    variables?: Array<string>;
}
/**
 *
 * @export
 * @interface SettingsScheduleCap
 */
export interface SettingsScheduleCap {
    /**
     *
     * @type {string}
     * @memberof SettingsScheduleCap
     */
    availability?: SettingsScheduleCapAvailabilityEnum;
    /**
     *
     * @type {string}
     * @memberof SettingsScheduleCap
     */
    changeable?: SettingsScheduleCapChangeableEnum;
    /**
     *
     * @type {string}
     * @memberof SettingsScheduleCap
     */
    predefinable?: SettingsScheduleCapPredefinableEnum;
}

export const SettingsScheduleCapAvailabilityEnum = {
    Party: "PARTY",
    Puid: "PUID",
} as const;

export type SettingsScheduleCapAvailabilityEnum = (typeof SettingsScheduleCapAvailabilityEnum)[keyof typeof SettingsScheduleCapAvailabilityEnum];
export const SettingsScheduleCapChangeableEnum = {
    CanModify: "CAN_MODIFY",
    ReadOnly: "READ_ONLY",
} as const;

export type SettingsScheduleCapChangeableEnum = (typeof SettingsScheduleCapChangeableEnum)[keyof typeof SettingsScheduleCapChangeableEnum];
export const SettingsScheduleCapPredefinableEnum = {
    Predefinable: "PREDEFINABLE",
    None: "NONE",
} as const;

export type SettingsScheduleCapPredefinableEnum = (typeof SettingsScheduleCapPredefinableEnum)[keyof typeof SettingsScheduleCapPredefinableEnum];

/**
 *
 * @export
 * @interface SimultaneousRing
 */
export interface SimultaneousRing {
    /**
     *
     * @type {string}
     * @memberof SimultaneousRing
     */
    inherit?: SimultaneousRingInheritEnum;
    /**
     *
     * @type {Array<SIMRNGEntry>}
     * @memberof SimultaneousRing
     */
    simrngList?: Array<SIMRNGEntry>;
    /**
     *
     * @type {string}
     * @memberof SimultaneousRing
     */
    status?: SimultaneousRingStatusEnum;
}

export const SimultaneousRingInheritEnum = {
    Primary: "PRIMARY",
    Self: "SELF",
} as const;

export type SimultaneousRingInheritEnum = (typeof SimultaneousRingInheritEnum)[keyof typeof SimultaneousRingInheritEnum];
export const SimultaneousRingStatusEnum = {
    On: "ON",
    Off: "OFF",
} as const;

export type SimultaneousRingStatusEnum = (typeof SimultaneousRingStatusEnum)[keyof typeof SimultaneousRingStatusEnum];

/**
 *
 * @export
 * @interface SimultaneousRingCap
 */
export interface SimultaneousRingCap {
    /**
     *
     * @type {string}
     * @memberof SimultaneousRingCap
     */
    availability?: SimultaneousRingCapAvailabilityEnum;
    /**
     *
     * @type {string}
     * @memberof SimultaneousRingCap
     */
    changeable?: SimultaneousRingCapChangeableEnum;
    /**
     *
     * @type {string}
     * @memberof SimultaneousRingCap
     */
    predefinable?: SimultaneousRingCapPredefinableEnum;
}

export const SimultaneousRingCapAvailabilityEnum = {
    Party: "PARTY",
    Puid: "PUID",
} as const;

export type SimultaneousRingCapAvailabilityEnum = (typeof SimultaneousRingCapAvailabilityEnum)[keyof typeof SimultaneousRingCapAvailabilityEnum];
export const SimultaneousRingCapChangeableEnum = {
    CanModify: "CAN_MODIFY",
    ReadOnly: "READ_ONLY",
} as const;

export type SimultaneousRingCapChangeableEnum = (typeof SimultaneousRingCapChangeableEnum)[keyof typeof SimultaneousRingCapChangeableEnum];
export const SimultaneousRingCapPredefinableEnum = {
    Predefinable: "PREDEFINABLE",
    None: "NONE",
} as const;

export type SimultaneousRingCapPredefinableEnum = (typeof SimultaneousRingCapPredefinableEnum)[keyof typeof SimultaneousRingCapPredefinableEnum];

/**
 *
 * @export
 * @interface SpeedDial100
 */
export interface SpeedDial100 {
    /**
     *
     * @type {string}
     * @memberof SpeedDial100
     */
    inherit?: SpeedDial100InheritEnum;
    /**
     *
     * @type {Array<SpeedDial100Entry>}
     * @memberof SpeedDial100
     */
    spd100Lists?: Array<SpeedDial100Entry>;
}

export const SpeedDial100InheritEnum = {
    Primary: "PRIMARY",
    Self: "SELF",
} as const;

export type SpeedDial100InheritEnum = (typeof SpeedDial100InheritEnum)[keyof typeof SpeedDial100InheritEnum];

/**
 *
 * @export
 * @interface SpeedDial100Cap
 */
export interface SpeedDial100Cap {
    /**
     *
     * @type {string}
     * @memberof SpeedDial100Cap
     */
    availability?: SpeedDial100CapAvailabilityEnum;
    /**
     *
     * @type {string}
     * @memberof SpeedDial100Cap
     */
    changeable?: SpeedDial100CapChangeableEnum;
    /**
     *
     * @type {string}
     * @memberof SpeedDial100Cap
     */
    predefinable?: SpeedDial100CapPredefinableEnum;
}

export const SpeedDial100CapAvailabilityEnum = {
    Party: "PARTY",
    Puid: "PUID",
} as const;

export type SpeedDial100CapAvailabilityEnum = (typeof SpeedDial100CapAvailabilityEnum)[keyof typeof SpeedDial100CapAvailabilityEnum];
export const SpeedDial100CapChangeableEnum = {
    CanModify: "CAN_MODIFY",
    ReadOnly: "READ_ONLY",
} as const;

export type SpeedDial100CapChangeableEnum = (typeof SpeedDial100CapChangeableEnum)[keyof typeof SpeedDial100CapChangeableEnum];
export const SpeedDial100CapPredefinableEnum = {
    Predefinable: "PREDEFINABLE",
    None: "NONE",
} as const;

export type SpeedDial100CapPredefinableEnum = (typeof SpeedDial100CapPredefinableEnum)[keyof typeof SpeedDial100CapPredefinableEnum];

/**
 *
 * @export
 * @interface SpeedDial100Entry
 */
export interface SpeedDial100Entry {
    /**
     *
     * @type {string}
     * @memberof SpeedDial100Entry
     */
    code?: string;
    /**
     *
     * @type {string}
     * @memberof SpeedDial100Entry
     */
    number?: string;
}
/**
 *
 * @export
 * @interface SpeedDial8
 */
export interface SpeedDial8 {
    /**
     *
     * @type {string}
     * @memberof SpeedDial8
     */
    inherit?: SpeedDial8InheritEnum;
    /**
     *
     * @type {Array<SpeedDial8Entry>}
     * @memberof SpeedDial8
     */
    spd8Lists?: Array<SpeedDial8Entry>;
}

export const SpeedDial8InheritEnum = {
    Primary: "PRIMARY",
    Self: "SELF",
} as const;

export type SpeedDial8InheritEnum = (typeof SpeedDial8InheritEnum)[keyof typeof SpeedDial8InheritEnum];

/**
 *
 * @export
 * @interface SpeedDial8Cap
 */
export interface SpeedDial8Cap {
    /**
     *
     * @type {string}
     * @memberof SpeedDial8Cap
     */
    availability?: SpeedDial8CapAvailabilityEnum;
    /**
     *
     * @type {string}
     * @memberof SpeedDial8Cap
     */
    changeable?: SpeedDial8CapChangeableEnum;
    /**
     *
     * @type {string}
     * @memberof SpeedDial8Cap
     */
    predefinable?: SpeedDial8CapPredefinableEnum;
}

export const SpeedDial8CapAvailabilityEnum = {
    Party: "PARTY",
    Puid: "PUID",
} as const;

export type SpeedDial8CapAvailabilityEnum = (typeof SpeedDial8CapAvailabilityEnum)[keyof typeof SpeedDial8CapAvailabilityEnum];
export const SpeedDial8CapChangeableEnum = {
    CanModify: "CAN_MODIFY",
    ReadOnly: "READ_ONLY",
} as const;

export type SpeedDial8CapChangeableEnum = (typeof SpeedDial8CapChangeableEnum)[keyof typeof SpeedDial8CapChangeableEnum];
export const SpeedDial8CapPredefinableEnum = {
    Predefinable: "PREDEFINABLE",
    None: "NONE",
} as const;

export type SpeedDial8CapPredefinableEnum = (typeof SpeedDial8CapPredefinableEnum)[keyof typeof SpeedDial8CapPredefinableEnum];

/**
 *
 * @export
 * @interface SpeedDial8Entry
 */
export interface SpeedDial8Entry {
    /**
     *
     * @type {string}
     * @memberof SpeedDial8Entry
     */
    code?: string;
    /**
     *
     * @type {string}
     * @memberof SpeedDial8Entry
     */
    number?: string;
}
/**
 *
 * @export
 * @interface TimeOriginatedRCCap
 */
export interface TimeOriginatedRCCap {
    /**
     *
     * @type {string}
     * @memberof TimeOriginatedRCCap
     */
    availability?: TimeOriginatedRCCapAvailabilityEnum;
    /**
     *
     * @type {string}
     * @memberof TimeOriginatedRCCap
     */
    changeable?: TimeOriginatedRCCapChangeableEnum;
    /**
     *
     * @type {string}
     * @memberof TimeOriginatedRCCap
     */
    predefinable?: TimeOriginatedRCCapPredefinableEnum;
}

export const TimeOriginatedRCCapAvailabilityEnum = {
    Party: "PARTY",
    Puid: "PUID",
} as const;

export type TimeOriginatedRCCapAvailabilityEnum = (typeof TimeOriginatedRCCapAvailabilityEnum)[keyof typeof TimeOriginatedRCCapAvailabilityEnum];
export const TimeOriginatedRCCapChangeableEnum = {
    CanModify: "CAN_MODIFY",
    ReadOnly: "READ_ONLY",
} as const;

export type TimeOriginatedRCCapChangeableEnum = (typeof TimeOriginatedRCCapChangeableEnum)[keyof typeof TimeOriginatedRCCapChangeableEnum];
export const TimeOriginatedRCCapPredefinableEnum = {
    Predefinable: "PREDEFINABLE",
    None: "NONE",
} as const;

export type TimeOriginatedRCCapPredefinableEnum = (typeof TimeOriginatedRCCapPredefinableEnum)[keyof typeof TimeOriginatedRCCapPredefinableEnum];

/**
 *
 * @export
 * @interface TimeZone
 */
export interface TimeZone {
    /**
     *
     * @type {string}
     * @memberof TimeZone
     */
    inherit?: TimeZoneInheritEnum;
    /**
     *
     * @type {string}
     * @memberof TimeZone
     */
    userTimeZone?: string;
}

export const TimeZoneInheritEnum = {
    Primary: "PRIMARY",
    Self: "SELF",
} as const;

export type TimeZoneInheritEnum = (typeof TimeZoneInheritEnum)[keyof typeof TimeZoneInheritEnum];

/**
 *
 * @export
 * @interface Vdd
 */
export interface Vdd {
    /**
     *
     * @type {string}
     * @memberof Vdd
     */
    inherit?: VddInheritEnum;
    /**
     *
     * @type {string}
     * @memberof Vdd
     */
    intraVpnRingPattern?: VddIntraVpnRingPatternEnum;
}

export const VddInheritEnum = {
    Primary: "PRIMARY",
    Self: "SELF",
} as const;

export type VddInheritEnum = (typeof VddInheritEnum)[keyof typeof VddInheritEnum];
export const VddIntraVpnRingPatternEnum = {
    Standard: "STANDARD",
    Pattern1: "PATTERN_1",
    Pattern2: "PATTERN_2",
    Pattern3: "PATTERN_3",
    Pattern4: "PATTERN_4",
    Pattern5: "PATTERN_5",
    Pattern6: "PATTERN_6",
} as const;

export type VddIntraVpnRingPatternEnum = (typeof VddIntraVpnRingPatternEnum)[keyof typeof VddIntraVpnRingPatternEnum];

/**
 *
 * @export
 * @interface VddCap
 */
export interface VddCap {
    /**
     *
     * @type {string}
     * @memberof VddCap
     */
    availability?: VddCapAvailabilityEnum;
    /**
     *
     * @type {string}
     * @memberof VddCap
     */
    changeable?: VddCapChangeableEnum;
    /**
     *
     * @type {string}
     * @memberof VddCap
     */
    escapeToVpnDialCode?: string;
    /**
     *
     * @type {string}
     * @memberof VddCap
     */
    predefinable?: VddCapPredefinableEnum;
}

export const VddCapAvailabilityEnum = {
    Party: "PARTY",
    Puid: "PUID",
} as const;

export type VddCapAvailabilityEnum = (typeof VddCapAvailabilityEnum)[keyof typeof VddCapAvailabilityEnum];
export const VddCapChangeableEnum = {
    CanModify: "CAN_MODIFY",
    ReadOnly: "READ_ONLY",
} as const;

export type VddCapChangeableEnum = (typeof VddCapChangeableEnum)[keyof typeof VddCapChangeableEnum];
export const VddCapPredefinableEnum = {
    Predefinable: "PREDEFINABLE",
    None: "NONE",
} as const;

export type VddCapPredefinableEnum = (typeof VddCapPredefinableEnum)[keyof typeof VddCapPredefinableEnum];

/**
 *
 * @export
 * @interface VoiceMailCap
 */
export interface VoiceMailCap {
    /**
     *
     * @type {string}
     * @memberof VoiceMailCap
     */
    availability?: VoiceMailCapAvailabilityEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceMailCap
     */
    changeable?: VoiceMailCapChangeableEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceMailCap
     */
    predefinable?: VoiceMailCapPredefinableEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceMailCap
     */
    vmsNumber?: string;
}

export const VoiceMailCapAvailabilityEnum = {
    Party: "PARTY",
    Puid: "PUID",
} as const;

export type VoiceMailCapAvailabilityEnum = (typeof VoiceMailCapAvailabilityEnum)[keyof typeof VoiceMailCapAvailabilityEnum];
export const VoiceMailCapChangeableEnum = {
    CanModify: "CAN_MODIFY",
    ReadOnly: "READ_ONLY",
} as const;

export type VoiceMailCapChangeableEnum = (typeof VoiceMailCapChangeableEnum)[keyof typeof VoiceMailCapChangeableEnum];
export const VoiceMailCapPredefinableEnum = {
    Predefinable: "PREDEFINABLE",
    None: "NONE",
} as const;

export type VoiceMailCapPredefinableEnum = (typeof VoiceMailCapPredefinableEnum)[keyof typeof VoiceMailCapPredefinableEnum];

/**
 *
 * @export
 * @interface WarmLineType
 */
export interface WarmLineType {
    /**
     *
     * @type {string}
     * @memberof WarmLineType
     */
    controlLevel?: WarmLineTypeControlLevelEnum;
    /**
     *
     * @type {boolean}
     * @memberof WarmLineType
     */
    isWarmLine?: boolean;
}

export const WarmLineTypeControlLevelEnum = {
    Full: "EDIT_FULL",
    Partial: "EDIT_PARTIAL",
    None: "EDIT_NONE",
} as const;

export type WarmLineTypeControlLevelEnum = (typeof WarmLineTypeControlLevelEnum)[keyof typeof WarmLineTypeControlLevelEnum];

/**
 * CapabilityAPIApi - axios parameter creator
 * @export
 */
export const CapabilityAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary get capability of the subscriber
         * @param {string} puid The PUID is the phone number of the user that is provisioned in the Nokia TAS.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCapability: async (puid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'puid' is not null or undefined
            assertParamExists("getCapability", "puid", puid);
            const localVarPath = `/v1/capabilities/puid/{puid}`.replace(`{${"puid"}}`, encodeURIComponent(String(puid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = {
                method: "GET",
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};

/**
 * CapabilityAPIApi - functional programming interface
 * @export
 */
export const CapabilityAPIApiFp = function (configuration?: Configuration) {
    const localVarAxiosParamCreator = CapabilityAPIApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary get capability of the subscriber
         * @param {string} puid The PUID is the phone number of the user that is provisioned in the Nokia TAS.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCapability(
            puid: string,
            options?: RawAxiosRequestConfig,
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommunicationCapabilities>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCapability(puid, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap["CapabilityAPIApi.getCapability"]?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    };
};

/**
 * CapabilityAPIApi - factory interface
 * @export
 */
export const CapabilityAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CapabilityAPIApiFp(configuration);
    return {
        /**
         *
         * @summary get capability of the subscriber
         * @param {string} puid The PUID is the phone number of the user that is provisioned in the Nokia TAS.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCapability(puid: string, options?: any): AxiosPromise<CommunicationCapabilities> {
            return localVarFp.getCapability(puid, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CapabilityAPIApi - object-oriented interface
 * @export
 * @class CapabilityAPIApi
 * @extends {BaseAPI}
 */
export class CapabilityAPIApi extends BaseAPI {
    /**
     *
     * @summary get capability of the subscriber
     * @param {string} puid The PUID is the phone number of the user that is provisioned in the Nokia TAS.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CapabilityAPIApi
     */
    public getCapability(puid: string, options?: RawAxiosRequestConfig) {
        return CapabilityAPIApiFp(this.configuration)
            .getCapability(puid, options)
            .then((request) => request(this.axios, this.basePath));
    }
}

/**
 * PUIDManagementAPIApi - axios parameter creator
 * @export
 */
export const PUIDManagementAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Get the PUID list of the subscriber
         * @param {string} puid The PUID is the phone number of the user that is provisioned in the Nokia TAS.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPuidListPerPuid: async (puid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'puid' is not null or undefined
            assertParamExists("getPuidListPerPuid", "puid", puid);
            const localVarPath = `/v1/puidlist/puid/{puid}`.replace(`{${"puid"}}`, encodeURIComponent(String(puid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = {
                method: "GET",
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};

/**
 * PUIDManagementAPIApi - functional programming interface
 * @export
 */
export const PUIDManagementAPIApiFp = function (configuration?: Configuration) {
    const localVarAxiosParamCreator = PUIDManagementAPIApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Get the PUID list of the subscriber
         * @param {string} puid The PUID is the phone number of the user that is provisioned in the Nokia TAS.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPuidListPerPuid(puid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PuidList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPuidListPerPuid(puid, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap["PUIDManagementAPIApi.getPuidListPerPuid"]?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    };
};

/**
 * PUIDManagementAPIApi - factory interface
 * @export
 */
export const PUIDManagementAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PUIDManagementAPIApiFp(configuration);
    return {
        /**
         *
         * @summary Get the PUID list of the subscriber
         * @param {string} puid The PUID is the phone number of the user that is provisioned in the Nokia TAS.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPuidListPerPuid(puid: string, options?: any): AxiosPromise<PuidList> {
            return localVarFp.getPuidListPerPuid(puid, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PUIDManagementAPIApi - object-oriented interface
 * @export
 * @class PUIDManagementAPIApi
 * @extends {BaseAPI}
 */
export class PUIDManagementAPIApi extends BaseAPI {
    /**
     *
     * @summary Get the PUID list of the subscriber
     * @param {string} puid The PUID is the phone number of the user that is provisioned in the Nokia TAS.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PUIDManagementAPIApi
     */
    public getPuidListPerPuid(puid: string, options?: RawAxiosRequestConfig) {
        return PUIDManagementAPIApiFp(this.configuration)
            .getPuidListPerPuid(puid, options)
            .then((request) => request(this.axios, this.basePath));
    }
}

/**
 * UserCurrentSettingsManagementAPIApi - axios parameter creator
 * @export
 */
export const UserCurrentSettingsManagementAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Get the locales of the system.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocales: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/settings/locales`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = {
                method: "GET",
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Outgoing Call Barring (OCB) prevents a user from placing outgoing calls on the basis of called address. It checks whether the dialed address matches an entry in the barring program that is active for the calling subscriber, this API is used to retrieve CM data for Outgoing Call Barring and store them locally.
         * @summary Get Outgoing Call Barring for subscribers.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOcbPrograms: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/settings/outgoingCallBarringPrograms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = {
                method: "GET",
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get current settings of the subscriber
         * @param {string} puid The PUID is the phone number of the user that is provisioned in the Nokia TAS.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSettings: async (puid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'puid' is not null or undefined
            assertParamExists("getSettings", "puid", puid);
            const localVarPath = `/v1/settings/puid/{puid}`.replace(`{${"puid"}}`, encodeURIComponent(String(puid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = {
                method: "GET",
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update settings for the subscriber
         * @param {string} puid The PUID is the phone number of the user that is provisioned in the Nokia TAS.
         * @param {CommunicationSettings} settings Current settings of the subscriber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSettings: async (puid: string, settings: CommunicationSettings, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'puid' is not null or undefined
            assertParamExists("updateSettings", "puid", puid);
            // verify required parameter 'settings' is not null or undefined
            assertParamExists("updateSettings", "settings", settings);
            const localVarPath = `/v1/settings/puid/{puid}`.replace(`{${"puid"}}`, encodeURIComponent(String(puid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = {
                method: "POST",
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter["Content-Type"] = "application/json";

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = serializeDataIfNeeded(settings, localVarRequestOptions, configuration);

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};

/**
 * UserCurrentSettingsManagementAPIApi - functional programming interface
 * @export
 */
export const UserCurrentSettingsManagementAPIApiFp = function (configuration?: Configuration) {
    const localVarAxiosParamCreator = UserCurrentSettingsManagementAPIApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Get the locales of the system.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLocales(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Locales>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLocales(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap["UserCurrentSettingsManagementAPIApi.getLocales"]?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Outgoing Call Barring (OCB) prevents a user from placing outgoing calls on the basis of called address. It checks whether the dialed address matches an entry in the barring program that is active for the calling subscriber, this API is used to retrieve CM data for Outgoing Call Barring and store them locally.
         * @summary Get Outgoing Call Barring for subscribers.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOcbPrograms(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OcbPrograms>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOcbPrograms(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap["UserCurrentSettingsManagementAPIApi.getOcbPrograms"]?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         *
         * @summary Get current settings of the subscriber
         * @param {string} puid The PUID is the phone number of the user that is provisioned in the Nokia TAS.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSettings(
            puid: string,
            options?: RawAxiosRequestConfig,
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommunicationSettings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSettings(puid, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap["UserCurrentSettingsManagementAPIApi.getSettings"]?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         *
         * @summary Update settings for the subscriber
         * @param {string} puid The PUID is the phone number of the user that is provisioned in the Nokia TAS.
         * @param {CommunicationSettings} settings Current settings of the subscriber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSettings(
            puid: string,
            settings: CommunicationSettings,
            options?: RawAxiosRequestConfig,
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSettings(puid, settings, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap["UserCurrentSettingsManagementAPIApi.updateSettings"]?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    };
};

/**
 * UserCurrentSettingsManagementAPIApi - factory interface
 * @export
 */
export const UserCurrentSettingsManagementAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserCurrentSettingsManagementAPIApiFp(configuration);
    return {
        /**
         *
         * @summary Get the locales of the system.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocales(options?: any): AxiosPromise<Locales> {
            return localVarFp.getLocales(options).then((request) => request(axios, basePath));
        },
        /**
         * Outgoing Call Barring (OCB) prevents a user from placing outgoing calls on the basis of called address. It checks whether the dialed address matches an entry in the barring program that is active for the calling subscriber, this API is used to retrieve CM data for Outgoing Call Barring and store them locally.
         * @summary Get Outgoing Call Barring for subscribers.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOcbPrograms(options?: any): AxiosPromise<OcbPrograms> {
            return localVarFp.getOcbPrograms(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get current settings of the subscriber
         * @param {string} puid The PUID is the phone number of the user that is provisioned in the Nokia TAS.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSettings(puid: string, options?: any): AxiosPromise<CommunicationSettings> {
            return localVarFp.getSettings(puid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update settings for the subscriber
         * @param {string} puid The PUID is the phone number of the user that is provisioned in the Nokia TAS.
         * @param {CommunicationSettings} settings Current settings of the subscriber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSettings(puid: string, settings: CommunicationSettings, options?: any): AxiosPromise<void> {
            return localVarFp.updateSettings(puid, settings, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserCurrentSettingsManagementAPIApi - object-oriented interface
 * @export
 * @class UserCurrentSettingsManagementAPIApi
 * @extends {BaseAPI}
 */
export class UserCurrentSettingsManagementAPIApi extends BaseAPI {
    /**
     *
     * @summary Get the locales of the system.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserCurrentSettingsManagementAPIApi
     */
    public getLocales(options?: RawAxiosRequestConfig) {
        return UserCurrentSettingsManagementAPIApiFp(this.configuration)
            .getLocales(options)
            .then((request) => request(this.axios, this.basePath));
    }

    /**
     * Outgoing Call Barring (OCB) prevents a user from placing outgoing calls on the basis of called address. It checks whether the dialed address matches an entry in the barring program that is active for the calling subscriber, this API is used to retrieve CM data for Outgoing Call Barring and store them locally.
     * @summary Get Outgoing Call Barring for subscribers.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserCurrentSettingsManagementAPIApi
     */
    public getOcbPrograms(options?: RawAxiosRequestConfig) {
        return UserCurrentSettingsManagementAPIApiFp(this.configuration)
            .getOcbPrograms(options)
            .then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get current settings of the subscriber
     * @param {string} puid The PUID is the phone number of the user that is provisioned in the Nokia TAS.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserCurrentSettingsManagementAPIApi
     */
    public getSettings(puid: string, options?: RawAxiosRequestConfig) {
        return UserCurrentSettingsManagementAPIApiFp(this.configuration)
            .getSettings(puid, options)
            .then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Update settings for the subscriber
     * @param {string} puid The PUID is the phone number of the user that is provisioned in the Nokia TAS.
     * @param {CommunicationSettings} settings Current settings of the subscriber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserCurrentSettingsManagementAPIApi
     */
    public updateSettings(puid: string, settings: CommunicationSettings, options?: RawAxiosRequestConfig) {
        return UserCurrentSettingsManagementAPIApiFp(this.configuration)
            .updateSettings(puid, settings, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
